import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, isRef as _isRef, withKeys as _withKeys, vShow as _vShow } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "cdr-strip-badge"
}
const _hoisted_3 = { class: "cdr-av-list-wrap" }
const _hoisted_4 = ["onClick", "onMouseenter"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["title"]
const _hoisted_8 = {
  key: 0,
  class: "cdr-strip-empty"
}
const _hoisted_9 = { class: "cdr-ttc-head" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "cdr-ttc-headinfo" }
const _hoisted_13 = { class: "cdr-ttc-row1" }
const _hoisted_14 = { class: "cdr-ttc-name" }
const _hoisted_15 = { class: "cdr-ttc-body" }
const _hoisted_16 = {
  key: 0,
  class: "cdr-ttc-row cdr-ttc-row--phone"
}
const _hoisted_17 = {
  key: 1,
  class: "cdr-ttc-row"
}
const _hoisted_18 = {
  key: 2,
  class: "cdr-ttc-row"
}
const _hoisted_19 = { class: "cdr-ttc-status" }
const _hoisted_20 = { class: "cdr-head" }
const _hoisted_21 = { class: "cdr-head-title" }
const _hoisted_22 = { class: "cdr-head-badge" }
const _hoisted_23 = {
  key: 0,
  class: "cdr-search"
}
const _hoisted_24 = {
  key: 1,
  class: "cdr-empty"
}
const _hoisted_25 = {
  key: 2,
  class: "cdr-empty"
}
const _hoisted_26 = {
  key: 3,
  class: "cdr-list"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "cdr-item-av-wrap" }
const _hoisted_29 = ["src", "alt"]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "cdr-item-body" }
const _hoisted_32 = { class: "cdr-item-r1" }
const _hoisted_33 = { class: "cdr-item-name" }
const _hoisted_34 = { class: "cdr-item-time" }
const _hoisted_35 = { class: "cdr-item-r2" }
const _hoisted_36 = { class: "cdr-item-preview" }
const _hoisted_37 = ["title"]
const _hoisted_38 = {
  key: 0,
  class: "cdr-item-lbls"
}
const _hoisted_39 = {
  key: 1,
  class: "cdr-item-assignee"
}
const _hoisted_40 = {
  key: 2,
  class: "cdr-item-fluxo"
}
const _hoisted_41 = { class: "cdr-head cdr-head--chat" }
const _hoisted_42 = {
  class: "cdr-item-av-wrap",
  style: {"margin":"0 3px 0 4px","position":"relative","flex-shrink":"0"}
}
const _hoisted_43 = ["src", "alt"]
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "cdr-chat-hinfo" }
const _hoisted_46 = { class: "cdr-chat-hname-row" }
const _hoisted_47 = ["title"]
const _hoisted_48 = { class: "cdr-chat-hcontact" }
const _hoisted_49 = {
  key: 0,
  class: "cdr-chat-hphone"
}
const _hoisted_50 = ["title"]
const _hoisted_51 = {
  key: 0,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_52 = {
  key: 1,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_53 = ["title"]
const _hoisted_54 = { class: "cdr-chat-hsub" }
const _hoisted_55 = ["title"]
const _hoisted_56 = {
  key: 2,
  class: "cdr-fluxo-tag",
  title: "Fluxo da conversa"
}
const _hoisted_57 = {
  key: 4,
  class: "cdr-agent-tag",
  title: "Time"
}
const _hoisted_58 = {
  key: 5,
  class: "cdr-agent-tag",
  title: "Agente"
}
const _hoisted_59 = { class: "cdr-hactions" }
const _hoisted_60 = ["title"]
const _hoisted_61 = {
  key: 0,
  class: "cdr-status-menu"
}
const _hoisted_62 = {
  key: 4,
  class: "cdr-snooze"
}
const _hoisted_63 = { class: "cdr-snooze-presets" }
const _hoisted_64 = ["disabled", "onClick"]
const _hoisted_65 = {
  class: "cdr-snooze-custom",
  for: "cdr-snooze-at"
}
const _hoisted_66 = ["min"]
const _hoisted_67 = ["disabled"]
const _hoisted_68 = {
  key: 0,
  class: "cdr-snooze-err"
}
const _hoisted_69 = ["disabled", "title"]
const _hoisted_70 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_71 = {
  key: 1,
  class: "cdr-spinner",
  style: {"width":"10px","height":"10px","border-width":"2px"}
}
const _hoisted_72 = ["title"]
const _hoisted_73 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_74 = {
  key: 1,
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_75 = { class: "cdr-chat-lbls" }
const _hoisted_76 = {
  key: 2,
  class: "cdr-agent-menu"
}
const _hoisted_77 = { class: "cdr-agent-search-wrap" }
const _hoisted_78 = {
  key: 0,
  style: {"padding":"12px","display":"flex","justify-content":"center"}
}
const _hoisted_79 = {
  key: 1,
  class: "cdr-agent-list"
}
const _hoisted_80 = ["onClick"]
const _hoisted_81 = { class: "cdr-agent-av-wrap" }
const _hoisted_82 = ["src", "alt"]
const _hoisted_83 = { key: 1 }
const _hoisted_84 = {
  key: 0,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"#22c55e","flex-shrink":"0"}
}
const _hoisted_85 = {
  key: 2,
  class: "cdr-agent-menu"
}
const _hoisted_86 = { class: "cdr-agent-search-wrap" }
const _hoisted_87 = {
  key: 0,
  style: {"padding":"12px","display":"flex","justify-content":"center"}
}
const _hoisted_88 = {
  key: 1,
  class: "cdr-agent-list"
}
const _hoisted_89 = ["onClick"]
const _hoisted_90 = {
  key: 0,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"#22c55e","flex-shrink":"0"}
}
const _hoisted_91 = ["onClick", "disabled"]
const _hoisted_92 = {
  key: 1,
  class: "cdr-lbl-lock",
  width: "9",
  height: "9",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  title: "Etiqueta protegida — não pode ser removida"
}
const _hoisted_93 = {
  key: 2,
  class: "cdr-lbl-picker"
}
const _hoisted_94 = ["disabled"]
const _hoisted_95 = {
  key: 0,
  class: "cdr-lbl-dropdown"
}
const _hoisted_96 = {
  key: 0,
  class: "cdr-lbl-loading"
}
const _hoisted_97 = ["onClick"]
const _hoisted_98 = { class: "cdr-lbl-opt-name" }
const _hoisted_99 = {
  key: 0,
  width: "11",
  height: "11",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"var(--ink-40)","flex-shrink":"0"},
  title: "Etiqueta protegida — não pode ser removida"
}
const _hoisted_100 = {
  key: 1,
  width: "11",
  height: "11",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"#22c55e","flex-shrink":"0"}
}
const _hoisted_101 = {
  key: 0,
  class: "cdr-window-banner cdr-observer-banner"
}
const _hoisted_102 = {
  key: 1,
  class: "cdr-window-banner"
}
const _hoisted_103 = {
  key: 2,
  class: "cdr-msg-search-bar"
}
const _hoisted_104 = {
  key: 0,
  class: "cdr-msg-search-count"
}
const _hoisted_105 = {
  key: 3,
  class: "cdr-macro-panel"
}
const _hoisted_106 = { class: "cdr-macro-head" }
const _hoisted_107 = { class: "cdr-macro-run-title" }
const _hoisted_108 = { class: "cdr-macro-form" }
const _hoisted_109 = { class: "cdr-mform-card" }
const _hoisted_110 = { class: "cdr-mform-label" }
const _hoisted_111 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_112 = { class: "cdr-macro-head" }
const _hoisted_113 = { class: "cdr-macro-search-wrap" }
const _hoisted_114 = { class: "cdr-macro-count" }
const _hoisted_115 = {
  key: 0,
  class: "cdr-macro-loading"
}
const _hoisted_116 = {
  key: 1,
  class: "cdr-macro-list"
}
const _hoisted_117 = ["onClick"]
const _hoisted_118 = { class: "cdr-macro-item-body" }
const _hoisted_119 = { class: "cdr-macro-item-name" }
const _hoisted_120 = { class: "cdr-macro-item-sub" }
const _hoisted_121 = {
  key: 0,
  class: "cdr-macro-empty"
}
const _hoisted_122 = { class: "cdr-macro-head" }
const _hoisted_123 = { class: "cdr-macro-run-title" }
const _hoisted_124 = {
  key: 1,
  class: "cdr-spinner",
  style: {"width":"12px","height":"12px","border-width":"2px","flex-shrink":"0"}
}
const _hoisted_125 = {
  key: 0,
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_126 = {
  key: 1,
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_127 = {
  key: 0,
  class: "cdr-msgs-loading"
}
const _hoisted_128 = {
  key: 1,
  class: "cdr-msg-skeleton"
}
const _hoisted_129 = {
  key: 0,
  class: "cdr-load-more-row"
}
const _hoisted_130 = {
  key: 1,
  class: "cdr-no-more"
}
const _hoisted_131 = ["data-msg-id"]
const _hoisted_132 = {
  key: 0,
  class: "cdr-msg-act"
}
const _hoisted_133 = ["title"]
const _hoisted_134 = ["src", "alt"]
const _hoisted_135 = { key: 1 }
const _hoisted_136 = {
  key: 1,
  class: "cdr-msg-av-spacer"
}
const _hoisted_137 = {
  key: 0,
  class: "cdr-priv-tag"
}
const _hoisted_138 = ["innerHTML"]
const _hoisted_139 = {
  key: 2,
  class: "cdr-att"
}
const _hoisted_140 = ["href"]
const _hoisted_141 = ["src"]
const _hoisted_142 = {
  key: 1,
  class: "cdr-ap"
}
const _hoisted_143 = ["onClick"]
const _hoisted_144 = {
  key: 0,
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_145 = {
  key: 1,
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_146 = { class: "cdr-ap-mid" }
const _hoisted_147 = ["value", "onInput"]
const _hoisted_148 = { class: "cdr-ap-time" }
const _hoisted_149 = ["href"]
const _hoisted_150 = {
  key: 2,
  class: "cdr-att-video-wrap"
}
const _hoisted_151 = ["src"]
const _hoisted_152 = ["href"]
const _hoisted_153 = { class: "cdr-att-file-info" }
const _hoisted_154 = { class: "cdr-att-file-ext" }
const _hoisted_155 = { class: "cdr-bubble-ts" }
const _hoisted_156 = {
  key: 0,
  class: "copilot-tag",
  title: "Enviada automaticamente pelo copiloto de IA"
}
const _hoisted_157 = {
  key: 4,
  class: "cdr-files"
}
const _hoisted_158 = { class: "cdr-file-name" }
const _hoisted_159 = ["onClick"]
const _hoisted_160 = {
  key: 6,
  class: "cdr-finished",
  role: "status"
}
const _hoisted_161 = ["disabled"]
const _hoisted_162 = ["disabled", "title"]
const _hoisted_163 = ["placeholder", "disabled", "onKeydown"]
const _hoisted_164 = ["disabled"]
const _hoisted_165 = {
  key: 0,
  class: "cdr-spinner-sm-white"
}
const _hoisted_166 = {
  key: 1,
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_167 = {
  key: 8,
  class: "cdr-recording"
}
const _hoisted_168 = { class: "cdr-rec-wave" }
const _hoisted_169 = { class: "cdr-rec-time" }
const _hoisted_170 = {
  key: 9,
  class: "cdr-rec-preview"
}
const _hoisted_171 = ["src"]
const _hoisted_172 = {
  key: 10,
  class: "cdr-vrec-wrap"
}
const _hoisted_173 = { class: "cdr-vrec-bar" }
const _hoisted_174 = {
  class: "cdr-rec-time",
  style: {"flex":"1","text-align":"left"}
}
const _hoisted_175 = {
  key: 11,
  class: "cdr-vrec-wrap"
}
const _hoisted_176 = ["src"]
const _hoisted_177 = { class: "cdr-tpl-dialog" }
const _hoisted_178 = { class: "cdr-tpl-head" }
const _hoisted_179 = { class: "cdr-tpl-title" }
const _hoisted_180 = { class: "cdr-tpl-contact-name" }
const _hoisted_181 = { class: "cdr-tpl-body" }
const _hoisted_182 = { class: "cdr-tpl-list-col" }
const _hoisted_183 = {
  key: 0,
  class: "cdr-tpl-loading"
}
const _hoisted_184 = {
  key: 1,
  class: "cdr-tpl-loading"
}
const _hoisted_185 = {
  key: 2,
  class: "cdr-tpl-items"
}
const _hoisted_186 = ["onClick"]
const _hoisted_187 = { class: "cdr-tpl-item-name" }
const _hoisted_188 = { class: "cdr-tpl-item-meta" }
const _hoisted_189 = { class: "cdr-tpl-lang" }
const _hoisted_190 = { class: "cdr-tpl-config-col" }
const _hoisted_191 = {
  key: 0,
  class: "cdr-tpl-pick-hint"
}
const _hoisted_192 = { class: "cdr-tpl-preview-wrap" }
const _hoisted_193 = { class: "cdr-tpl-bubble" }
const _hoisted_194 = {
  key: 0,
  class: "cdr-tpl-bubble-img"
}
const _hoisted_195 = ["src"]
const _hoisted_196 = {
  key: 1,
  class: "cdr-tpl-img-ph"
}
const _hoisted_197 = {
  key: 1,
  class: "cdr-tpl-bubble-hdr"
}
const _hoisted_198 = ["innerHTML"]
const _hoisted_199 = {
  key: 2,
  class: "cdr-tpl-bubble-ftr"
}
const _hoisted_200 = { class: "cdr-tpl-bubble-time" }
const _hoisted_201 = {
  key: 0,
  class: "cdr-tpl-btns"
}
const _hoisted_202 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_203 = {
  key: 1,
  style: {"margin-top":"12px"}
}
const _hoisted_204 = { class: "cdr-tpl-field-lbl" }
const _hoisted_205 = {
  key: 0,
  class: "cdr-tpl-mapped-badge"
}
const _hoisted_206 = ["placeholder", "value", "onInput"]
const _hoisted_207 = { style: {"margin-top":"16px"} }
const _hoisted_208 = ["disabled"]
const _hoisted_209 = { key: 0 }
const _hoisted_210 = {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"vertical-align":"-2px","margin-right":"5px"}
}
const _hoisted_211 = {
  key: 1,
  class: "cdr-tpl-spin",
  style: {"border-top-color":"#fff","border-color":"rgba(255,255,255,.3)"}
}

import { ref, computed, nextTick, watch, onMounted, onUnmounted, reactive } from 'vue'
import { loadMessageAvatars, senderOf, sameSender } from '@/composables/useMessageAvatars'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { avatarColor, initials } from '@/composables/useHelpers'
import { fmtPhone } from '@/utils/contactsFormat'
import { toMediaUrl } from '@/utils/media'
import { pendingChatId, currentOpenConvId, closeDrawerSignal, focusReplySignal, openMyConvsSignal, activeConvContext } from '@/composables/useChatTrigger'
import { useChatRailMode } from '@/composables/useChatRailMode'
import { usePermission } from '@/composables/usePermission'
import Swal from 'sweetalert2'
import EmojiPicker from '@/components/dashboard/EmojiPicker.vue'
import { useMessageCacheCp } from '@/composables/useMessageCacheCp'
import { useMessageSearchCp } from '@/composables/useMessageSearchCp'
import { useMessageWindowCp } from '@/composables/useMessageWindowCp'
import { useAudioRecorderCp } from '@/composables/useAudioRecorderCp'
import { useWhatsappTemplatesCp } from '@/composables/useWhatsappTemplatesCp'
import { useRailConversations } from '@/composables/useRailConversations'
import { onConversationMessage, onConversationStatus, onRealtimeRecovered, onListChanged, type MessageStatusNotification } from '@/composables/useConversationRealtime'
import { useWhatsAppPresence } from '@/composables/useWhatsAppPresence'
import MessageTicks from '@/components/dashboard/MessageTicks.vue'
import CopilotBar from '@/components/dashboard/CopilotBar.vue'
import LinkusCallButton from '@/components/dashboard/LinkusCallButton.vue'
import AgendorBadge from '@/components/agendor/AgendorBadge.vue'
import AgendorMenu from '@/components/agendor/AgendorMenu.vue'
import BotVersionTag from '@/components/dashboard/BotVersionTag.vue'
import { useBotVersionRefresh } from '@/composables/useBotVersionRefresh'
import { playNotificationSound } from '@/composables/useNotificationSound'
import {
  listConversations, getConversation, getMessages, sendMessage, assignConversation, assignConversationTeam,
  resolveConversation, changeConversationStatus, snoozeConversation, addConversationTag, removeConversationTag, STATUS_LABEL,
  type ConversationListItem, type ConversationDetail,
} from '@/services/wootdashConversations'
import { listAgents, getAgent, type CpAgent } from '@/services/wootdashAgents'
import { listTeams, type CpTeam } from '@/services/wootdashTeams'
import { listTags, type CpTag } from '@/services/wootdashTags'
import { uploadAttachment, MAX_ATTACHMENT_BYTES } from '@/services/wootdashAttachments'
import { listMacros, executeMacro, type CpMacro } from '@/services/wootdashMacros'
import type { ChatMessageCp, ProcessedMsgCp } from '@/types/chatCp'

const STRIP_W = 60
const MIN_W   = 260
const MAX_W   = 640
const PAGE_SIZE = 50


export default /*@__PURE__*/_defineComponent({
  __name: 'ConvDrawer',
  setup(__props) {

const { mode: railMode } = useChatRailMode()

const store    = useStore()
const route    = useRoute()
const token    = computed(() => store.getters.authUser?.wootdash_token ?? '')

// Modo observador do agente logado (aba Agentes): só acompanha — o envio pro contato é bloqueado aqui e no backend.
const iAmObserver = ref(false)
watch(() => store.getters.authUser?.wootdash_agent_id as string | undefined, async id => {
  iAmObserver.value = id ? !!(await getAgent(token.value, id).catch(() => null))?.isObserver : false
}, { immediate: true })
// O Modo Foco (/foco) já cobre "minhas conversas" na própria página — o rail flutuante
// fica escondido lá pra não ter duas fontes de "conversa atual" competindo na tela.
const hiddenOnFoco = computed(() => route.name === 'foco')

const { can } = usePermission()

/* ── Faixa de avatares (motor global, independente de página) — useRailConversations.ts:
   Administrador/Sistema veem toda conversa ativa do sistema aqui, os demais perfis só as
   próprias (ver comentário no composable). ─────────────────────────────────────────── */
const { railConversations: myConvsRaw } = useRailConversations()
// Conversa aberta que não está na lista acima (ex.: um perfil restrito abrindo pelo Dashboard
// uma conversa de outro agente) — precisa aparecer na faixa enquanto estiver aberta, senão a
// faixa fica vazia mostrando só os ícones genéricos de cabeçalho/rodapé/estado-vazio. Some
// de novo ao fechar ou trocar pra uma conversa que já está na lista real (ver openChat).
const adHocOpenConv = ref<ConversationListItem | null>(null)
const myConvs = computed(() =>
  adHocOpenConv.value ? [adHocOpenConv.value, ...myConvsRaw.value] : myConvsRaw.value
)

/* ── Status ──────────────────────────────── */
function convStatusClass(status: number): string {
  return ({ 0: 'open', 1: 'pending', 2: 'resolved', 3: 'closed' } as Record<number, string>)[status] ?? 'open'
}
function statusDot(conv: ConversationListItem): string {
  if (conv.status === 1) return 'dot-pending'
  return 'dot-open'
}
// Badge de não lidas (mensagens do contato que o agente logado não viu — useRailConversations.ts).
function unreadLabel(count: number): string {
  return count > 9 ? '9+' : String(count)
}
function unreadTitle(count: number): string {
  return count === 1 ? '1 mensagem não lida' : `${count} mensagens não lidas`
}
function statusDotDetail(conv: ConversationDetail): string {
  if (conv.status === 1) return 'dot-pending'
  return 'dot-open'
}
function statusLabel(conv: ConversationListItem): string {
  return STATUS_LABEL[conv.status] ?? 'Aberta'
}

/* ── State ───────────────────────────────── */
const listOpen    = ref(false)
const chatOpen    = ref(false)
const selConvId   = ref<string | null>(null)
const activeConv  = ref<ConversationDetail | null>(null)
useBotVersionRefresh(activeConv, () => token.value) // etiqueta da versão do bot sem polling
const { msgCache } = useMessageCacheCp()
const loadingMsgs = ref(false)
const loadingMore = ref(false)
const noMoreMsgs  = ref(false)
const draft       = ref('')
const files       = ref<File[]>([])
const notaInterna = ref(false)
/** Resolvida (2) ou fechada (3): o compositor some e o envio é recusado — reabrir libera. */
const cdrFinished = computed(() => activeConv.value?.status === 2 || activeConv.value?.status === 3)
const msgsEl      = ref<HTMLElement | null>(null)
const taEl        = ref<HTMLTextAreaElement | null>(null)
const fileInputEl = ref<HTMLInputElement | null>(null)
const stripListEl = ref<HTMLElement | null>(null)
const cdrNowSec   = ref(Math.floor(Date.now() / 1000))
const phoneCopied = ref(false)
const protocolCopied = ref(false)
const cdrStatusMenuOpen = ref(false)
const cdrExporting = ref(false)
const updatingLabels = ref(false)
const labelsOpen = ref(false)
const allTags = ref<CpTag[]>([])

/* ── Scroll do trilho de avatares (setas) ── */
const canScrollUp   = ref(false)
const canScrollDown = ref(false)

function updateStripScrollState() {
  const el = stripListEl.value
  if (!el) { canScrollUp.value = false; canScrollDown.value = false; return }
  canScrollUp.value   = el.scrollTop > 4
  canScrollDown.value = el.scrollTop + el.clientHeight < el.scrollHeight - 4
}
function scrollStrip(dir: 1 | -1) {
  stripListEl.value?.scrollBy({ top: dir * 120, behavior: 'smooth' })
}
watch(myConvs, () => nextTick(updateStripScrollState), { flush: 'post' })

/* ── Busca na lista "Minhas Conversas" ───── */
const convSearch = ref('')
const filteredMyConvs = computed(() => {
  const q = convSearch.value.trim().toLowerCase()
  if (!q) return myConvs.value
  return myConvs.value.filter(c =>
    c.contactName.toLowerCase().includes(q) || (c.contactPhone ?? '').toLowerCase().includes(q))
})
const panelVisible = computed(() => (listOpen.value || chatOpen.value) && railMode.value === 'client' && !hiddenOnFoco.value)
watch(panelVisible, open => { if (!open) convSearch.value = '' })

/* ── Atribuição de agente ─────────────────── */
const agentMenuOpen = ref(false)
const agentLoading  = ref(false)
const allAgents     = ref<CpAgent[]>([])
const agentSearch   = ref('')
let _agentsFetched  = false

const filteredAgents = computed(() => {
  const q = agentSearch.value.toLowerCase().trim()
  // Modo observador nunca recebe conversa: fica fora da lista de atribuição.
  const assignable = allAgents.value.filter(a => !a.isObserver)
  return q ? assignable.filter(a => `${a.firstName} ${a.lastName}`.toLowerCase().includes(q)) : assignable
})

async function fetchAgents() {
  if (agentLoading.value || _agentsFetched) return
  _agentsFetched = true
  agentLoading.value = true
  try {
    const { agents } = await listAgents(token.value)
    allAgents.value = agents
  } catch {
    _agentsFetched = false
  } finally {
    agentLoading.value = false
  }
}

async function doAssignAgent(agentId: string) {
  if (!activeConv.value) return
  agentMenuOpen.value = false
  agentSearch.value = ''
  const agent = allAgents.value.find(a => a.id === agentId)
  const ok = await assignConversation(token.value, activeConv.value.id, agentId)
  if (ok && agent) {
    activeConv.value = { ...activeConv.value, agentId: agent.id, agentName: `${agent.firstName} ${agent.lastName}` }
  }
}

function onAgentDocClick() { agentMenuOpen.value = false; agentSearch.value = '' }
watch(agentMenuOpen, open => {
  if (open) { fetchAgents(); setTimeout(() => document.addEventListener('click', onAgentDocClick), 0) }
  else document.removeEventListener('click', onAgentDocClick)
})

/* ── Atribuição de time ───────────────────── */
const cdrTeamMenuOpen = ref(false)
const cdrTeamsLoading = ref(false)
const cdrTeamsList    = ref<CpTeam[]>([])
const cdrTeamSearch   = ref('')
let _cdrTeamsFetched  = false

const filteredCdrTeams = computed(() => {
  const q = cdrTeamSearch.value.toLowerCase().trim()
  return q ? cdrTeamsList.value.filter(t => t.name.toLowerCase().includes(q)) : cdrTeamsList.value
})

async function fetchCdrTeams() {
  if (_cdrTeamsFetched) return
  cdrTeamsLoading.value = true
  try {
    cdrTeamsList.value = await listTeams(token.value)
    _cdrTeamsFetched = true
  } catch { /* silencioso */ } finally {
    cdrTeamsLoading.value = false
  }
}

async function doAssignCdrTeam(teamId: string) {
  if (!activeConv.value) return
  cdrTeamMenuOpen.value = false
  cdrTeamSearch.value = ''
  const team = cdrTeamsList.value.find(t => t.id === teamId)
  const ok = await assignConversationTeam(token.value, activeConv.value.id, teamId)
  if (ok && team) {
    activeConv.value = { ...activeConv.value, teamId: team.id, teamName: team.name }
  }
}

function onCdrTeamDocClick() { cdrTeamMenuOpen.value = false; cdrTeamSearch.value = '' }
watch(cdrTeamMenuOpen, open => {
  if (open) { fetchCdrTeams(); setTimeout(() => document.addEventListener('click', onCdrTeamDocClick), 0) }
  else document.removeEventListener('click', onCdrTeamDocClick)
})

/* ── Etiquetas ────────────────────────────── */
async function fetchAllTags() {
  if (allTags.value.length) return
  try { allTags.value = await listTags(token.value) } catch { /* silencioso */ }
}

function isTagProtected(name: string): boolean {
  return allTags.value.find(t => t.name === name)?.isProtected ?? false
}

async function toggleTag(name: string) {
  if (!activeConv.value || updatingLabels.value) return
  const conv = activeConv.value
  const tag = allTags.value.find(t => t.name === name)
  if (!tag) return
  const has = conv.tagNames.includes(name)
  updatingLabels.value = true
  try {
    const ok = has ? await removeConversationTag(token.value, conv.id, tag.id) : await addConversationTag(token.value, conv.id, tag.id)
    if (ok) {
      activeConv.value = {
        ...conv,
        tagNames: has ? conv.tagNames.filter(n => n !== name) : [...conv.tagNames, name],
      }
    }
  } finally {
    updatingLabels.value = false
  }
}

function onLblDocClick(e: MouseEvent) {
  const el = document.querySelector('.cdr-lbl-picker')
  if (el && !el.contains(e.target as Node)) labelsOpen.value = false
}
watch(labelsOpen, open => {
  if (open) { fetchAllTags(); setTimeout(() => document.addEventListener('click', onLblDocClick), 0) }
  else document.removeEventListener('click', onLblDocClick)
})

/* ── Tooltip ─────────────────────────────── */
const tt = ref<{ conv: ConversationListItem; y: number } | null>(null)
function showTT(conv: ConversationListItem, e: MouseEvent) {
  const rect = (e.currentTarget as HTMLElement).getBoundingClientRect()
  tt.value = { conv, y: Math.round(rect.top + rect.height / 2) }
}
function hideTT() { tt.value = null }

/* ── Áudio (player + gravação) ────────────── */
const {
  audioState, toggleAudio, seekAudio, audioProgress, fmtTime, disposeAudioEls,
  recording, recordingTime, recordedBlob, recordedUrl, waveformBars,
  startRecording, stopRecording, cancelRecording, sendRecordedAudio, fmtRecordingTime,
} = useAudioRecorderCp({
  barCount: 28,
  exclusivePlayback: true,
  onSend: async (file) => { files.value = [file]; await sendMsg() },
})

/* ── Gravação de vídeo ───────────────────── */
const videoRecording     = ref(false)
const videoRecordingTime = ref(0)
const videoRecordedBlob  = ref<Blob | null>(null)
const videoRecordedUrl   = ref('')
const videoPreviewEl     = ref<HTMLVideoElement | null>(null)
let _vmr: MediaRecorder | null = null
let _vstream: MediaStream | null = null
let _vrecTimer: ReturnType<typeof setInterval> | null = null

async function startVideoRecording() {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true })
    _vstream = stream
    const chunks: Blob[] = []
    const mimeType = MediaRecorder.isTypeSupported('video/webm;codecs=vp9,opus')
      ? 'video/webm;codecs=vp9,opus'
      : MediaRecorder.isTypeSupported('video/webm') ? 'video/webm' : 'video/mp4'
    _vmr = new MediaRecorder(stream, { mimeType })
    _vmr.ondataavailable = e => { if (e.data.size > 0) chunks.push(e.data) }
    _vmr.onstop = () => {
      const blob = new Blob(chunks, { type: mimeType })
      videoRecordedBlob.value = blob
      if (videoRecordedUrl.value) URL.revokeObjectURL(videoRecordedUrl.value)
      videoRecordedUrl.value = URL.createObjectURL(blob)
      stream.getTracks().forEach(t => t.stop())
    }
    _vmr.start(100)
    videoRecording.value = true
    videoRecordingTime.value = 0
    _vrecTimer = setInterval(() => videoRecordingTime.value++, 1000)
    await nextTick()
    if (videoPreviewEl.value) videoPreviewEl.value.srcObject = stream
  } catch {
    Swal.fire({ title: 'Câmera inacessível', text: 'Não foi possível acessar a câmera. Verifique as permissões do navegador.', icon: 'error' })
  }
}
function stopVideoRecording() {
  _vmr?.stop()
  videoRecording.value = false
  if (_vrecTimer) { clearInterval(_vrecTimer); _vrecTimer = null }
}
function cancelVideoRecording() {
  if (videoRecording.value) {
    if (_vmr) { _vmr.onstop = null; _vmr.stop() }
    _vstream?.getTracks().forEach(t => t.stop())
    videoRecording.value = false
    if (_vrecTimer) { clearInterval(_vrecTimer); _vrecTimer = null }
  }
  videoRecordedBlob.value = null
  if (videoRecordedUrl.value) { URL.revokeObjectURL(videoRecordedUrl.value); videoRecordedUrl.value = '' }
}
async function sendRecordedVideo() {
  if (!videoRecordedBlob.value) return
  const ext = videoRecordedBlob.value.type.includes('mp4') ? 'mp4' : 'webm'
  const file = new File([videoRecordedBlob.value], `video_${Date.now()}.${ext}`, { type: videoRecordedBlob.value.type })
  videoRecordedBlob.value = null
  if (videoRecordedUrl.value) { URL.revokeObjectURL(videoRecordedUrl.value); videoRecordedUrl.value = '' }
  files.value = [file]
  await sendMsg()
}

const panelWidth = ref(Math.max(MIN_W, Math.min(MAX_W, parseInt(localStorage.getItem('cdr_panel_w') || '320'))))

/* ── Templates WhatsApp ──────────────────── */
const {
  tplOpen: cdrTplOpen, tplsLoading: cdrTplsLoading, tplsApproved: cdrTplsApproved,
  tplSel: cdrTplSel, tplVarNums: cdrTplVarNums, tplVars: cdrTplVars, tplVarMapping: cdrTplVarMapping, tplImgUrl: cdrTplImgUrl,
  tplImgErr: cdrTplImgErr, tplSending: cdrTplSending, tplTime: cdrTplTime,
  tplHasImg: cdrTplHasImg, tplHeaderTxt: cdrTplHeaderTxt, tplFooterTxt: cdrTplFooterTxt,
  tplButtons: cdrTplButtons, tplPreviewHtml: cdrTplPreviewHtml,
  openTplModal: openCdrTplModal, closeTplModal: closeCdrTplModal,
  selectTpl: selectCdrTpl, setTplVar: setCdrTplVar, sendTpl: sendCdrTpl, mappedLabel: cdrMappedLabel,
} = useWhatsappTemplatesCp({
  getToken: () => token.value,
  getConversationId: () => activeConv.value?.id ?? null,
  onSent: () => { if (selConvId.value) fetchMsgs(selConvId.value, true) },
})

/* ── Macros ──────────────────────────────── */
const cdrMacroPanelOpen  = ref(false)
const cdrMacrosList      = ref<CpMacro[]>([])
const cdrMacrosLoading   = ref(false)
const cdrMacroSearch     = ref('')
const cdrMacroRunning    = ref(false)
const cdrMacroRunDone    = ref(false)
const cdrMacroRunningObj = ref<CpMacro | null>(null)
const cdrMacroResult     = ref<{ success: boolean; failureReason: string; actionsApplied: number } | null>(null)
const cdrMacroFormTarget = ref<CpMacro | null>(null)
const cdrMacroFormValues = ref<Record<string, string>>({})

const cdrMacroFormFields = computed(() => {
  if (!cdrMacroFormTarget.value) return []
  const fields: { key: string; label: string }[] = []
  const seen = new Set<string>()
  for (const action of cdrMacroFormTarget.value.actions) {
    if (action.type !== 'send_webhook_with_form' || !action.fields) continue
    for (const f of action.fields) {
      if (!seen.has(f.key)) { seen.add(f.key); fields.push(f) }
    }
  }
  return fields
})

const cdrFilteredMacros = computed(() => {
  const q = cdrMacroSearch.value.trim().toLowerCase()
  return q ? cdrMacrosList.value.filter(m => m.name.toLowerCase().includes(q)) : cdrMacrosList.value
})

async function loadCdrMacros() {
  if (cdrMacrosList.value.length) return
  cdrMacrosLoading.value = true
  try {
    cdrMacrosList.value = await listMacros(token.value)
  } catch { /* silencioso */ } finally {
    cdrMacrosLoading.value = false
  }
}

function toggleCdrMacroPanel() {
  cdrMacroPanelOpen.value = !cdrMacroPanelOpen.value
  if (cdrMacroPanelOpen.value) { loadCdrMacros(); resetCdrMacroRun() }
}

function resetCdrMacroRun() {
  cdrMacroRunning.value    = false
  cdrMacroRunDone.value    = false
  cdrMacroRunningObj.value = null
  cdrMacroResult.value     = null
  cdrMacroFormTarget.value = null
  cdrMacroFormValues.value = {}
}

function runCdrMacro(macro: CpMacro) {
  const hasForm = macro.actions.some(a => a.type === 'send_webhook_with_form' && a.fields?.length)
  if (hasForm) {
    cdrMacroFormValues.value = {}
    cdrMacroFormTarget.value = macro
    return
  }
  executeCdrMacro(macro, undefined)
}

function submitCdrMacroForm() {
  if (!cdrMacroFormTarget.value) return
  const macro = cdrMacroFormTarget.value
  const values = { ...cdrMacroFormValues.value }
  cdrMacroFormTarget.value = null
  executeCdrMacro(macro, values)
}

async function executeCdrMacro(macro: CpMacro, formValues: Record<string, string> | undefined) {
  if (!activeConv.value) return
  cdrMacroRunningObj.value = macro
  cdrMacroRunning.value    = true
  cdrMacroRunDone.value    = false
  cdrMacroResult.value     = await executeMacro(token.value, macro.id, activeConv.value.id, formValues)
  cdrMacroRunning.value    = false
  cdrMacroRunDone.value    = true
  if (selConvId.value) fetchMsgs(selConvId.value, true)
}

/* ── SLA badge (classificado no backend — só exibe) ───────────────────────── */
const activeSLABadge = computed<{ label: string; time: string; status: 'breached' | 'atRisk' } | null>(() => {
  const conv = activeConv.value
  if (!conv || !conv.slaDueAt) return null
  const due = new Date(conv.slaDueAt).getTime() / 1000
  const now = cdrNowSec.value
  const remaining = due - now
  const breached = !!conv.slaBreachedAt || remaining <= 0
  if (!breached && remaining > 15 * 60) return null // só mostra estourado/em risco (15min), igual antes
  const abs = Math.abs(Math.floor(remaining))
  const h = Math.floor(abs / 3600), m = Math.floor((abs % 3600) / 60), s = abs % 60
  const timeStr = remaining <= 0
    ? `+${h > 0 ? h + 'h ' : ''}${m > 0 ? m + 'min' : s + 's'}`
    : `${h > 0 ? h + 'h ' : ''}${m > 0 ? m + 'min' : s + 's'}`
  return { label: conv.slaPhase || 'SLA', time: timeStr, status: breached ? 'breached' : 'atRisk' }
})

/* ── Mensagens processadas ───────────────── */
const processedMsgs = computed<ProcessedMsgCp[]>(() => {
  if (!selConvId.value) return []
  const msgs = msgCache.value[selConvId.value] || []
  return msgs.map((msg, i) => {
    const next = msgs[i + 1]
    // Avatar só na última de uma sequência da MESMA pessoa (dois agentes seguidos mostram os dois).
    const showAvatar = !sameSender(next, msg)
    return { ...msg, showAvatar }
  })
})

const canSend = computed(() => draft.value.trim().length > 0 || files.value.length > 0)
const { isWindowClosed: cdrWindowClosed } = useMessageWindowCp(processedMsgs, cdrNowSec)
watch(cdrWindowClosed, (closed) => { if (closed) notaInterna.value = false })

function isImageMime(mime: string | null): boolean { return !!mime && mime.startsWith('image/') }
function isAudioMime(mime: string | null): boolean { return !!mime && mime.startsWith('audio/') }
function isVideoMime(mime: string | null): boolean { return !!mime && mime.startsWith('video/') }
function isPdfMime(mime: string | null): boolean { return mime === 'application/pdf' }

/* ── Message search ──────────────────────── */
const {
  msgSearchOpen, msgSearchQuery, msgSearchActive, msgSearchLoading, msgCurrentIdx, msgSearchInputEl,
  msgMatchIds, highlightMsgHtml,
  openMsgSearch, closeMsgSearch, doMsgSearch, goNextMsg, goPrevMsg,
} = useMessageSearchCp({ processedMsgs, msgsEl, loadMoreMsgs, noMoreMsgs })

/* ── Panel control ───────────────────────── */
function toggleList() {
  if (chatOpen.value) { chatOpen.value = false; listOpen.value = true; return }
  listOpen.value = !listOpen.value
}
function closePanel() {
  listOpen.value = false
  chatOpen.value = false
  selConvId.value = null
  activeConv.value = null
  currentOpenConvId.value = null
  adHocOpenConv.value = null
}
function backToList() {
  chatOpen.value = false
  listOpen.value = true
}

async function exportActiveConv() {
  const conv = activeConv.value
  if (!conv || cdrExporting.value) return
  cdrExporting.value = true
  try {
    const messages = await getMessages(token.value, conv.id)
    const lines = messages.map(m => {
      const who = m.senderType === 'Agent' ? 'Agente' : m.senderType === 'Bot' ? 'Bot' : m.senderType === 'System' ? 'Sistema' : conv.contactName
      const when = new Date(m.createdAt).toLocaleString('pt-BR')
      const body = m.body || (m.mediaUrl ? `[anexo: ${m.mediaUrl}]` : '')
      return `[${when}] ${who}${m.isPrivateNote ? ' (nota interna)' : ''}: ${body}`
    }).join('\n')
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>Conversa ${conv.contactName}</title></head>` +
      `<body><h1>${conv.contactName}</h1><pre style="white-space:pre-wrap;font-family:sans-serif">${lines.replace(/</g, '&lt;')}</pre></body></html>`
    const blob = new Blob([html], { type: 'text/html' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `conversa-${conv.id}-${new Date().toISOString().slice(0, 10)}.html`
    a.click()
    URL.revokeObjectURL(url)
  } catch (e: any) {
    Swal.fire({ title: 'Erro ao exportar', text: e.message || 'Não foi possível buscar as mensagens.', icon: 'error' })
  } finally {
    cdrExporting.value = false
  }
}

function selectConv(conv: ConversationListItem) {
  hideTT()
  if (selConvId.value === conv.id && chatOpen.value) { closePanel(); return }
  openChat(conv)
}

async function openChat(conv: ConversationListItem) {
  selConvId.value = conv.id
  void loadMessageAvatars(token.value)
  listOpen.value  = false
  chatOpen.value  = true
  labelsOpen.value = false
  adHocOpenConv.value = myConvsRaw.value.some(c => c.id === conv.id) ? null : conv
  fetchAllTags()
  const detail = await getConversation(token.value, conv.id)
  if (selConvId.value !== conv.id) return
  activeConv.value = detail
  const hadCache = !!msgCache.value[conv.id]
  await fetchMsgs(conv.id, hadCache)
  if (selConvId.value === conv.id) { await nextTick(); scrollBottom() }
}

async function openById(id: string) {
  let conv = myConvs.value.find(c => c.id === id)
  if (!conv) {
    const detail = await getConversation(token.value, id)
    if (!detail) {
      Swal.fire({ title: 'Conversa não encontrada', text: `Não foi possível abrir a conversa.`, icon: 'error' })
      return
    }
    conv = {
      id: detail.id, contactId: detail.contactId, contactName: detail.contactName, contactPhone: detail.contactPhone,
      contactAvatarUrl: detail.contactAvatarUrl, status: detail.status, agentId: detail.agentId, agentName: detail.agentName,
      flowId: detail.flowId, flowName: detail.flowName, teamId: detail.teamId, teamName: detail.teamName,
      tagNames: detail.tagNames, lastMessagePreview: null, lastMessageSenderType: null, lastMessageAt: null,
      resolvedAt: null, createdAt: detail.createdAt,
    }
  }
  await openChat(conv)
}

watch(pendingChatId, async (id) => {
  if (id === null) return
  pendingChatId.value = null
  railMode.value = 'client'
  currentOpenConvId.value = id
  await openById(String(id))
})

watch(closeDrawerSignal, (val) => {
  if (val > 0 && (chatOpen.value || listOpen.value)) closePanel()
})
watch(focusReplySignal, (val) => {
  if (val > 0 && chatOpen.value) nextTick(() => taEl.value?.focus())
})
watch(openMyConvsSignal, (val) => {
  if (val === 0) return
  if (railMode.value !== 'client') { railMode.value = 'client'; listOpen.value = true }
  else toggleList()
})
watch([activeConv, chatOpen], ([conv, open]) => {
  activeConvContext.value = open && conv ? { id: conv.id, fluxoId: null, cnpj: null } : null
})

/* ── Fetch messages ──────────────────────── */
function mergeMsgs(existing: ChatMessageCp[], incoming: ChatMessageCp[]): ChatMessageCp[] {
  const byId = new Map(existing.map(m => [m.id, m]))
  incoming.forEach(m => byId.set(m.id, m))
  return [...byId.values()].sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())
}
function isNearBottom(): boolean {
  const el = msgsEl.value
  if (!el) return true
  return el.scrollHeight - el.scrollTop - el.clientHeight < 120
}

async function fetchMsgs(convId: string, silent = true) {
  if (!silent) loadingMsgs.value = true
  noMoreMsgs.value = false
  const wasNearBottom = isNearBottom()
  try {
    const messages = await getMessages(token.value, convId, { limit: PAGE_SIZE })
    const prevMsgs = msgCache.value[convId]
    if (prevMsgs) {
      const prevIds = new Set(prevMsgs.map(m => m.id))
      if (messages.some(m => m.senderType === 'Contact' && !prevIds.has(m.id))) playNotificationSound()
    }
    msgCache.value = {
      ...msgCache.value,
      [convId]: silent && prevMsgs ? mergeMsgs(prevMsgs, messages) : messages,
    }
    noMoreMsgs.value = messages.length < PAGE_SIZE
  } catch (e) {
    console.error('[ConvDrawer]', e)
  } finally {
    loadingMsgs.value = false
    if (convId === selConvId.value && (!silent || wasNearBottom)) {
      await nextTick()
      scrollBottom()
    }
  }
}

function onRealtimeMsg(convId: string, message: ChatMessageCp) {
  const prevMsgs = msgCache.value[convId]
  if (!prevMsgs) { fetchMsgs(convId, true); return }
  const isNewIncoming = message.senderType === 'Contact' && !prevMsgs.some(m => m.id === message.id)
  const wasNearBottom = isNearBottom()
  msgCache.value = { ...msgCache.value, [convId]: mergeMsgs(prevMsgs, [message]) }
  if (isNewIncoming) playNotificationSound()
  if (isNewIncoming && convId === selConvId.value && chatOpen.value) presence.seen(convId)
  if (convId === selConvId.value && wasNearBottom) nextTick(() => scrollBottom())
}

/** Tique novo (enviada/entregue/lida/falhou) numa mensagem já na tela. */
function onRealtimeStatus(convId: string, evt: MessageStatusNotification) {
  const msgs = msgCache.value[convId]
  if (!msgs?.some(m => m.id === evt.messageId)) return
  msgCache.value = {
    ...msgCache.value,
    [convId]: msgs.map(m => m.id === evt.messageId ? { ...m, deliveryStatus: evt.status, deliveryError: evt.error } : m),
  }
}

async function loadMoreMsgs() {
  const convId = selConvId.value
  if (!convId || loadingMore.value || noMoreMsgs.value) return
  const current = msgCache.value[convId] ?? []
  if (!current.length) return
  loadingMore.value = true
  const prevHeight = msgsEl.value?.scrollHeight ?? 0
  try {
    const older = await getMessages(token.value, convId, { before: current[0].createdAt, limit: PAGE_SIZE })
    if (!older.length) { noMoreMsgs.value = true; return }
    msgCache.value = { ...msgCache.value, [convId]: mergeMsgs(older, current) }
    await nextTick()
    if (msgsEl.value) msgsEl.value.scrollTop = msgsEl.value.scrollHeight - prevHeight
  } catch (e) {
    console.error('[ConvDrawer loadMore]', e)
  } finally {
    loadingMore.value = false
  }
}

function onMsgsScroll() {
  if (msgsEl.value && msgsEl.value.scrollTop < 60) loadMoreMsgs()
}

/* ── Send ────────────────────────────────── */
const sending = ref(false)

// Copiloto: a sugestão entra no campo (o atendente revisa e envia); avisamos o envio pra medir o aproveitamento.
const copilotBar = ref<InstanceType<typeof CopilotBar> | null>(null)
function fillFromCopilot(text: string) {
  draft.value = text
  nextTick(() => growTa())
}

async function sendMsg() {
  const convId = selConvId.value
  if (!convId || sending.value || cdrFinished.value) return
  if (!draft.value.trim() && !files.value.length) return
  // Modo observador: o backend recusa mensagem pro contato — avisa antes e deixa o texto no campo.
  if (iAmObserver.value && !notaInterna.value) {
    Swal.fire({ icon: 'info', title: 'Modo observador', text: 'Você só acompanha as conversas: mensagem pro contato não sai. Use nota interna pra deixar um recado.', confirmButtonColor: '#BC0C24' })
    return
  }
  sending.value = true
  const text = draft.value.trim()
  const pickedFiles = [...files.value]
  const isPrivate = notaInterna.value
  draft.value = ''
  files.value = []
  nextTick(() => { growTa(); taEl.value?.focus() })
  try {
    if (text) {
      const ok = await sendMessage(token.value, convId, text, isPrivate)
      if (!ok) throw new Error('Falha ao enviar texto')
      if (!isPrivate) copilotBar.value?.sent(text)
    }
    presence.sent()
    const failed: string[] = []
    for (const file of pickedFiles) {
      const uploaded = file.size > MAX_ATTACHMENT_BYTES ? null : await uploadAttachment(token.value, file)
      if (!uploaded || !(await sendMessage(token.value, convId, null, isPrivate, uploaded))) failed.push(file.name)
    }
    if (failed.length) {
      Swal.fire({ title: 'Anexo não enviado', text: `Não foi possível enviar: ${failed.join(', ')}. O limite é 25 MB por arquivo.`, icon: 'warning' })
    }
    await fetchMsgs(convId, true)
  } catch (e) {
    console.error('[ConvDrawer] sendMsg:', e)
    Swal.fire({ title: 'Erro ao enviar', text: 'Não foi possível enviar a mensagem.', icon: 'error' })
  } finally {
    sending.value = false
  }
}

function onFilePick(e: Event) {
  const input = e.target as HTMLInputElement
  if (input.files) { files.value.push(...Array.from(input.files)); input.value = '' }
}
function growTa() {
  const el = taEl.value
  if (!el) return
  el.style.height = 'auto'
  el.style.height = Math.min(el.scrollHeight, 120) + 'px'
}
function insertEmoji(em: string) {
  const el = taEl.value
  if (!el) { draft.value += em; return }
  const start = el.selectionStart ?? draft.value.length
  const end   = el.selectionEnd   ?? draft.value.length
  draft.value = draft.value.slice(0, start) + em + draft.value.slice(end)
  nextTick(() => {
    el.selectionStart = el.selectionEnd = start + em.length
    el.focus()
    growTa()
  })
}
function scrollBottom() {
  if (msgsEl.value) msgsEl.value.scrollTop = msgsEl.value.scrollHeight
}

/* ── Resize ──────────────────────────────── */
let _rx = false, _sx = 0, _sw = 0
function startResize(e: MouseEvent) {
  _rx = true; _sx = e.clientX; _sw = panelWidth.value
  document.addEventListener('mousemove', doResize)
  document.addEventListener('mouseup', stopResize)
  document.body.style.userSelect = 'none'
  document.body.style.cursor = 'col-resize'
}
function doResize(e: MouseEvent) {
  if (!_rx) return
  panelWidth.value = Math.max(MIN_W, Math.min(MAX_W, _sw + (_sx - e.clientX)))
}
function stopResize() {
  _rx = false
  document.removeEventListener('mousemove', doResize)
  document.removeEventListener('mouseup', stopResize)
  document.body.style.userSelect = ''
  document.body.style.cursor = ''
  localStorage.setItem('cdr_panel_w', String(panelWidth.value))
}

/* ── Realtime da conversa aberta ──────────── */
let msgRealtimeUnsub: (() => void) | null = null
const presence = useWhatsAppPresence(token)
watch([chatOpen, selConvId], ([open, convId]) => {
  msgRealtimeUnsub?.()
  msgRealtimeUnsub = null
  if (open && convId) {
    const offMsg = onConversationMessage(convId, message => onRealtimeMsg(convId, message))
    const offStatus = onConversationStatus(convId, evt => onRealtimeStatus(convId, evt))
    // Conexão voltou depois de cair: busca o que chegou na queda e junta com o que já está na tela.
    const offRecovered = onRealtimeRecovered(() => fetchMsgs(convId, true))
    msgRealtimeUnsub = () => { offMsg(); offStatus(); offRecovered() }
    presence.seen(convId)
  }
})
function onVisibleAgain() {
  if (document.visibilityState === 'visible' && chatOpen.value) presence.seen(selConvId.value)
}

let _nowTimer: ReturnType<typeof setInterval> | null = null

onMounted(() => {
  _nowTimer = setInterval(() => { cdrNowSec.value = Math.floor(Date.now() / 1000) }, 30_000)
  document.addEventListener('visibilitychange', onVisibleAgain)
})

onUnmounted(() => {
  document.removeEventListener('mousemove', doResize)
  document.removeEventListener('mouseup', stopResize)
  if (_nowTimer) clearInterval(_nowTimer)
  document.removeEventListener('visibilitychange', onVisibleAgain)
  msgRealtimeUnsub?.()
  disposeAudioEls()
  cancelRecording()
  cancelVideoRecording()
  document.removeEventListener('click', onLblDocClick)
  document.removeEventListener('click', onCdrStatusDocClick)
  document.removeEventListener('click', onCdrTeamDocClick)
  document.removeEventListener('click', onAgentDocClick)
})

/* ── Helpers ─────────────────────────────── */
function convTime(conv: ConversationListItem): string {
  if (!conv.createdAt) return ''
  const d = new Date(conv.createdAt), now = new Date()
  return d.toDateString() === now.toDateString()
    ? d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    : d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })
}
function fmtTs(iso: string): string {
  const d = new Date(iso)
  return `${d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })} ${d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`
}
async function copyPhone(phone: string | null) {
  if (!phone) return
  await navigator.clipboard.writeText(phone)
  phoneCopied.value = true
  setTimeout(() => { phoneCopied.value = false }, 2000)
}

async function copyProtocol(protocol: string | null | undefined) {
  if (!protocol) return
  try { await navigator.clipboard.writeText(protocol) } catch { return }
  protocolCopied.value = true
  setTimeout(() => { protocolCopied.value = false }, 2000)
}

function onCdrStatusDocClick() { cdrStatusMenuOpen.value = false }
watch(cdrStatusMenuOpen, open => {
  if (open) setTimeout(() => document.addEventListener('click', onCdrStatusDocClick), 0)
  else document.removeEventListener('click', onCdrStatusDocClick)
})

async function cdrChangeStatus(status: 'Open' | 'Pending') {
  if (!activeConv.value) return
  cdrStatusMenuOpen.value = false
  cdrSnoozeOpen.value = false
  const ok = await changeConversationStatus(token.value, activeConv.value.id, status)
  // Trocar o status desfaz o adiamento (o backend limpa o prazo).
  if (ok) activeConv.value = { ...activeConv.value, status: status === 'Open' ? 0 : 1, snoozedUntil: null }
}

// ── Adiar com prazo ─────────────────────────────────────────────────────────────────────────────
const cdrSnoozeOpen = ref(false)
const cdrSnoozing = ref(false)
const cdrSnoozeError = ref('')
const cdrSnoozeAt = ref('')
const snoozeNow = ref(Date.now())
let snoozeTimer: ReturnType<typeof setInterval> | null = null

const inMinutes = (m: number) => () => new Date(Date.now() + m * 60_000)
function tomorrowAt(hour: number) {
  return () => { const d = new Date(); d.setDate(d.getDate() + 1); d.setHours(hour, 0, 0, 0); return d }
}
const SNOOZE_PRESETS = [
  { label: '15 min', at: inMinutes(15) },
  { label: '30 min', at: inMinutes(30) },
  { label: '1 hora', at: inMinutes(60) },
  { label: '2 horas', at: inMinutes(120) },
  { label: 'Amanhã 9h', at: tomorrowAt(9) },
]
/** datetime-local no fuso do navegador, sem segundos. */
function toLocalInput(d: Date) {
  const p = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`
}
const snoozeMin = computed(() => toLocalInput(new Date(snoozeNow.value + 60_000)))

function toggleSnoozePicker() {
  cdrSnoozeOpen.value = !cdrSnoozeOpen.value
  cdrSnoozeError.value = ''
  if (cdrSnoozeOpen.value && !cdrSnoozeAt.value) cdrSnoozeAt.value = toLocalInput(new Date(Date.now() + 60 * 60_000))
}

async function cdrSnooze(until: Date) {
  if (!activeConv.value || cdrSnoozing.value) return
  cdrSnoozing.value = true
  cdrSnoozeError.value = ''
  try {
    const snoozedUntil = await snoozeConversation(token.value, activeConv.value.id, until)
    activeConv.value = { ...activeConv.value, status: 1, snoozedUntil }
    cdrSnoozeOpen.value = false
    cdrStatusMenuOpen.value = false
  } catch (e: any) {
    cdrSnoozeError.value = e?.message || 'Não deu pra adiar a conversa.'
  } finally {
    cdrSnoozing.value = false
  }
}

/** Contagem do selo "Adiada · 29:41" (mm:ss; com horas, "1h 05min"). */
const snoozeLeft = computed(() => {
  const until = activeConv.value?.snoozedUntil
  if (!until) return ''
  const s = Math.max(0, Math.round((new Date(until).getTime() - snoozeNow.value) / 1000))
  if (s === 0) return 'vencendo…'
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  return h > 0 ? `${h}h ${String(m).padStart(2, '0')}min` : `${String(m).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`
})
const snoozeUntilLabel = computed(() => {
  const until = activeConv.value?.snoozedUntil
  return until ? new Date(until).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : ''
})
watch(() => activeConv.value?.snoozedUntil, until => {
  if (snoozeTimer) { clearInterval(snoozeTimer); snoozeTimer = null }
  if (until) snoozeTimer = setInterval(() => { snoozeNow.value = Date.now() }, 1000)
}, { immediate: true })
// A conversa aberta mudou em outro lugar (adiamento venceu no Worker, contato escreveu, outra aba): status e prazo na hora.
const offSnoozeListChanged = onListChanged(item => {
  const conv = activeConv.value
  if (!conv || item.id !== conv.id) return
  if (item.status !== conv.status || (item.snoozedUntil ?? null) !== (conv.snoozedUntil ?? null)) {
    activeConv.value = { ...conv, status: item.status, snoozedUntil: item.snoozedUntil ?? null }
  }
})
onUnmounted(() => {
  if (snoozeTimer) clearInterval(snoozeTimer)
  offSnoozeListChanged()
})

async function cdrResolve() {
  if (!activeConv.value) return
  cdrStatusMenuOpen.value = false
  const result = await Swal.fire({
    title: 'Resolver esta conversa?',
    html: 'Esta conversa será marcada como resolvida. Tem certeza?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#BC0C24',
    cancelButtonColor: '#6b7280',
    confirmButtonText: 'Sim, resolver',
    cancelButtonText: 'Cancelar',
    reverseButtons: true,
  })
  if (!result.isConfirmed) return
  const ok = await resolveConversation(token.value, activeConv.value.id)
  if (ok) backToList()
}

/** Foto + nome de quem mandou (atendente pelo senderId, agente de IA, bot, contato) — ver useMessageAvatars. */
function msgSender(msg: ChatMessageCp) {
  return senderOf(msg, { name: activeConv.value?.contactName, avatarUrl: activeConv.value?.contactAvatarUrl })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(railMode) === 'client' && !hiddenOnFoco.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["cdr-strip", { 'is-expanded': panelVisible.value }])
        }, [
          _cache[65] || (_cache[65] = _createElementVNode("div", { class: "cdr-strip-cap" }, null, -1)),
          _createElementVNode("div", {
            class: "cdr-strip-head",
            onClick: toggleList,
            title: listOpen.value ? 'Fechar' : 'Minhas conversas'
          }, [
            _cache[57] || (_cache[57] = _createElementVNode("svg", {
              width: "17",
              height: "17",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
            ], -1)),
            (myConvs.value.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(myConvs.value.length > 9 ? '9+' : myConvs.value.length), 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_1),
          _createElementVNode("div", _hoisted_3, [
            (canScrollUp.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "cdr-scroll-btn up",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollStrip(-1))),
                  title: "Rolar para cima"
                }, [...(_cache[58] || (_cache[58] = [
                  _createElementVNode("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("polyline", { points: "18 15 12 9 6 15" })
                  ], -1)
                ]))]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "cdr-av-list",
              ref_key: "stripListEl",
              ref: stripListEl,
              onScroll: updateStripScrollState
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myConvs.value, (conv) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: conv.id,
                  class: _normalizeClass(["cdr-av-item", { active: selConvId.value === conv.id }]),
                  onClick: ($event: any) => (selectConv(conv)),
                  onMouseenter: ($event: any) => (showTT(conv, $event)),
                  onMouseleave: hideTT
                }, [
                  _createElementVNode("div", {
                    class: "cdr-av",
                    style: _normalizeStyle({ background: _unref(avatarColor)(conv.contactName) })
                  }, [
                    (conv.contactAvatarUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(toMediaUrl)(conv.contactAvatarUrl),
                          alt: conv.contactName,
                          onError: _cache[1] || (_cache[1] = (e) => (e.target as HTMLImageElement).style.display='none')
                        }, null, 40, _hoisted_5))
                      : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(initials)(conv.contactName)), 1))
                  ], 4),
                  (conv.unreadCount)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "cdr-av-unread-badge",
                        title: unreadTitle(conv.unreadCount)
                      }, _toDisplayString(unreadLabel(conv.unreadCount)), 9, _hoisted_7))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: _normalizeClass(["cdr-status-dot", statusDot(conv)])
                  }, null, 2)
                ], 42, _hoisted_4))
              }), 128)),
              (!myConvs.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[59] || (_cache[59] = [
                    _createElementVNode("svg", {
                      width: "18",
                      height: "18",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "1.8",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true)
            ], 544),
            (canScrollDown.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "cdr-scroll-btn down",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (scrollStrip(1))),
                  title: "Rolar para baixo"
                }, [...(_cache[60] || (_cache[60] = [
                  _createElementVNode("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("polyline", { points: "6 9 12 15 18 9" })
                  ], -1)
                ]))]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
            _createVNode(_Transition, { name: "tt-pill" }, {
              default: _withCtx(() => [
                (tt.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "cdr-tt-card",
                      style: _normalizeStyle({ top: tt.value.y + 'px', right: (STRIP_W + 8) + 'px' })
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", {
                          class: "cdr-ttc-av",
                          style: _normalizeStyle({ background: _unref(avatarColor)(tt.value.conv.contactName) })
                        }, [
                          (tt.value.conv.contactAvatarUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _unref(toMediaUrl)(tt.value.conv.contactAvatarUrl),
                                alt: tt.value.conv.contactName,
                                onError: _cache[3] || (_cache[3] = (e) => (e.target as HTMLImageElement).style.display='none')
                              }, null, 40, _hoisted_10))
                            : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(initials)(tt.value.conv.contactName)), 1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(["cdr-ttc-av-dot", statusDot(tt.value.conv)])
                          }, null, 2)
                        ], 4),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(tt.value.conv.contactName || tt.value.conv.contactPhone), 1)
                          ])
                        ])
                      ]),
                      _cache[64] || (_cache[64] = _createElementVNode("div", { class: "cdr-ttc-divider" }, null, -1)),
                      _createElementVNode("div", _hoisted_15, [
                        (tt.value.conv.contactPhone)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                              _cache[61] || (_cache[61] = _createElementVNode("svg", {
                                width: "11",
                                height: "11",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("path", { d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13 19.79 19.79 0 0 1 1.61 4.44 2 2 0 0 1 3.59 2.24h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.29 6.29l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" })
                              ], -1)),
                              _createTextVNode(" " + _toDisplayString(_unref(fmtPhone)(tt.value.conv.contactPhone)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (tt.value.conv.teamName)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                              _cache[62] || (_cache[62] = _createElementVNode("svg", {
                                width: "11",
                                height: "11",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
                                _createElementVNode("circle", {
                                  cx: "9",
                                  cy: "7",
                                  r: "4"
                                }),
                                _createElementVNode("path", { d: "M23 21v-2a4 4 0 0 0-3-3.87" }),
                                _createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
                              ], -1)),
                              _createTextVNode(" " + _toDisplayString(tt.value.conv.teamName), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (tt.value.conv.agentName)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                              _cache[63] || (_cache[63] = _createElementVNode("svg", {
                                width: "11",
                                height: "11",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                                _createElementVNode("circle", {
                                  cx: "12",
                                  cy: "7",
                                  r: "4"
                                })
                              ], -1)),
                              _createTextVNode(" " + _toDisplayString(tt.value.conv.agentName), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_19, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["cdr-ttc-dot", statusDot(tt.value.conv)])
                          }, null, 2),
                          _createTextVNode(" " + _toDisplayString(statusLabel(tt.value.conv)), 1)
                        ])
                      ])
                    ], 4))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "cdr-panel" }, {
      default: _withCtx(() => [
        (panelVisible.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "cdr-panel",
              style: _normalizeStyle({ width: panelWidth.value + 'px', right: STRIP_W + 'px' })
            }, [
              _createElementVNode("div", {
                class: "cdr-resize-handle",
                onMousedown: _withModifiers(startResize, ["prevent"])
              }, null, 32),
              (!chatOpen.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _cache[66] || (_cache[66] = _createElementVNode("svg", {
                          width: "13",
                          height: "13",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
                        ], -1)),
                        _cache[67] || (_cache[67] = _createTextVNode(" Minhas Conversas ", -1)),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(myConvs.value.length), 1)
                      ]),
                      _createElementVNode("button", {
                        class: "cdr-icon-btn",
                        onClick: closePanel
                      }, [...(_cache[68] || (_cache[68] = [
                        _createElementVNode("svg", {
                          width: "12",
                          height: "12",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "3",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("line", {
                            x1: "18",
                            y1: "6",
                            x2: "6",
                            y2: "18"
                          }),
                          _createElementVNode("line", {
                            x1: "6",
                            y1: "6",
                            x2: "18",
                            y2: "18"
                          })
                        ], -1)
                      ]))])
                    ]),
                    (myConvs.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _cache[70] || (_cache[70] = _createElementVNode("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("circle", {
                              cx: "11",
                              cy: "11",
                              r: "8"
                            }),
                            _createElementVNode("line", {
                              x1: "21",
                              y1: "21",
                              x2: "16.65",
                              y2: "16.65"
                            })
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((convSearch).value = $event)),
                            type: "text",
                            class: "cdr-search-input",
                            placeholder: "Buscar conversa…"
                          }, null, 512), [
                            [_vModelText, convSearch.value]
                          ]),
                          (convSearch.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "cdr-search-clear",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (convSearch.value = '')),
                                title: "Limpar busca"
                              }, [...(_cache[69] || (_cache[69] = [
                                _createElementVNode("svg", {
                                  width: "11",
                                  height: "11",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "3",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }, [
                                  _createElementVNode("line", {
                                    x1: "18",
                                    y1: "6",
                                    x2: "6",
                                    y2: "18"
                                  }),
                                  _createElementVNode("line", {
                                    x1: "6",
                                    y1: "6",
                                    x2: "18",
                                    y2: "18"
                                  })
                                ], -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (!myConvs.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[71] || (_cache[71] = [
                          _createElementVNode("svg", {
                            width: "40",
                            height: "40",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "1.3",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
                          ], -1),
                          _createElementVNode("p", null, "Nenhuma conversa ativa atribuída a você", -1)
                        ]))]))
                      : (!filteredMyConvs.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _cache[72] || (_cache[72] = _createElementVNode("svg", {
                              width: "40",
                              height: "40",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "1.3",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("circle", {
                                cx: "11",
                                cy: "11",
                                r: "8"
                              }),
                              _createElementVNode("line", {
                                x1: "21",
                                y1: "21",
                                x2: "16.65",
                                y2: "16.65"
                              })
                            ], -1)),
                            _createElementVNode("p", null, "Nenhuma conversa encontrada para \"" + _toDisplayString(convSearch.value) + "\"", 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMyConvs.value, (conv) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: conv.id,
                                class: _normalizeClass(["cdr-item", { selected: selConvId.value === conv.id }]),
                                onClick: ($event: any) => (openChat(conv))
                              }, [
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("div", {
                                    class: "cdr-item-av",
                                    style: _normalizeStyle({ background: _unref(avatarColor)(conv.contactName) })
                                  }, [
                                    (conv.contactAvatarUrl)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: _unref(toMediaUrl)(conv.contactAvatarUrl),
                                          alt: conv.contactName,
                                          style: {"width":"100%","height":"100%","object-fit":"cover","border-radius":"50%"},
                                          onError: _cache[6] || (_cache[6] = (e) => (e.target as HTMLImageElement).style.display='none')
                                        }, null, 40, _hoisted_29))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_unref(initials)(conv.contactName)), 1))
                                  ], 4),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["cdr-status-dot sm", statusDot(conv)])
                                  }, null, 2)
                                ]),
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("span", _hoisted_33, [
                                      _createTextVNode(_toDisplayString(conv.contactName) + " ", 1),
                                      _createVNode(AgendorBadge, {
                                        "contact-id": conv.contactId,
                                        "conversation-id": conv.id,
                                        variant: "dark"
                                      }, null, 8, ["contact-id", "conversation-id"])
                                    ]),
                                    _createElementVNode("span", _hoisted_34, _toDisplayString(convTime(conv)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("span", _hoisted_36, _toDisplayString(conv.lastMessagePreview || 'Abrir conversa…'), 1),
                                    (conv.unreadCount)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "cdr-unread",
                                          title: unreadTitle(conv.unreadCount)
                                        }, _toDisplayString(unreadLabel(conv.unreadCount)), 9, _hoisted_37))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (conv.tagNames.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conv.tagNames.slice(0, 3), (l) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: l,
                                            class: "cdr-lbl"
                                          }, _toDisplayString(l), 1))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_unref(can)('dashboard.viewAgents') && conv.agentName)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                        _cache[73] || (_cache[73] = _createElementVNode("svg", {
                                          width: "9",
                                          height: "9",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2.5",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        }, [
                                          _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                                          _createElementVNode("circle", {
                                            cx: "12",
                                            cy: "7",
                                            r: "4"
                                          })
                                        ], -1)),
                                        _createTextVNode(" " + _toDisplayString(conv.agentName), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (conv.flowName)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(conv.flowName), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ], 10, _hoisted_27))
                            }), 128))
                          ]))
                  ], 64))
                : (activeConv.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("button", {
                          class: "cdr-icon-btn",
                          onClick: backToList,
                          title: "Voltar"
                        }, [...(_cache[74] || (_cache[74] = [
                          _createElementVNode("svg", {
                            width: "13",
                            height: "13",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "3",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
                          ], -1)
                        ]))]),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", {
                            class: "cdr-item-av sm2",
                            style: _normalizeStyle({ background: _unref(avatarColor)(activeConv.value.contactName) })
                          }, [
                            (activeConv.value.contactAvatarUrl)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _unref(toMediaUrl)(activeConv.value.contactAvatarUrl),
                                  alt: activeConv.value.contactName,
                                  style: {"width":"100%","height":"100%","object-fit":"cover","border-radius":"50%"},
                                  onError: _cache[7] || (_cache[7] = (e) => (e.target as HTMLImageElement).style.display='none')
                                }, null, 40, _hoisted_43))
                              : (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_unref(initials)(activeConv.value.contactName)), 1))
                          ], 4),
                          _createElementVNode("span", {
                            class: _normalizeClass(["cdr-status-dot sm", statusDotDetail(activeConv.value)]),
                            style: {"border-color":"#BC0C24"}
                          }, null, 2)
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("span", {
                              class: "cdr-chat-hname",
                              title: activeConv.value.contactName
                            }, _toDisplayString(activeConv.value.contactName), 9, _hoisted_47),
                            _createVNode(AgendorMenu, {
                              "contact-id": activeConv.value.contactId,
                              "conversation-id": activeConv.value.id,
                              "conversation-agent-id": activeConv.value.agentId,
                              "contact-name": activeConv.value.contactName,
                              variant: "dark"
                            }, null, 8, ["contact-id", "conversation-id", "conversation-agent-id", "contact-name"])
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            (activeConv.value.contactPhone)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                                  _cache[77] || (_cache[77] = _createElementVNode("svg", {
                                    width: "9",
                                    height: "9",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("path", { d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13 19.79 19.79 0 0 1 1.61 4.44 2 2 0 0 1 3.59 2.24h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.29 6.29l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" })
                                  ], -1)),
                                  _createTextVNode(" " + _toDisplayString(_unref(fmtPhone)(activeConv.value.contactPhone)) + " ", 1),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["cdr-phone-copy-btn", { 'is-copied': phoneCopied.value }]),
                                    onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (copyPhone(activeConv.value.contactPhone)), ["stop"])),
                                    title: phoneCopied.value ? 'Copiado!' : 'Copiar número'
                                  }, [
                                    (phoneCopied.value)
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_51, [...(_cache[75] || (_cache[75] = [
                                          _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                        ]))]))
                                      : (_openBlock(), _createElementBlock("svg", _hoisted_52, [...(_cache[76] || (_cache[76] = [
                                          _createElementVNode("rect", {
                                            x: "9",
                                            y: "9",
                                            width: "13",
                                            height: "13",
                                            rx: "2"
                                          }, null, -1),
                                          _createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" }, null, -1)
                                        ]))]))
                                  ], 10, _hoisted_50)
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(LinkusCallButton, {
                              class: "cdr-call",
                              variant: "dark",
                              "conversation-id": activeConv.value.id,
                              phone: activeConv.value.contactPhone,
                              "contact-name": activeConv.value.contactName
                            }, null, 8, ["conversation-id", "phone", "contact-name"]),
                            (activeConv.value.protocol)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: _normalizeClass(["cdr-protocol-tag", { 'is-copied': protocolCopied.value }]),
                                  title: protocolCopied.value ? 'Copiado!' : 'Protocolo — clique pra copiar',
                                  onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (copyProtocol(activeConv.value.protocol)), ["stop"]))
                                }, [
                                  _cache[78] || (_cache[78] = _createElementVNode("span", { class: "cdr-protocol-lbl" }, "Protocolo", -1)),
                                  _createTextVNode(" " + _toDisplayString(activeConv.value.protocol), 1)
                                ], 10, _hoisted_53))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("span", {
                              class: _normalizeClass(['cdr-status-lbl', convStatusClass(activeConv.value.status)])
                            }, _toDisplayString(_unref(STATUS_LABEL)[activeConv.value.status]), 3),
                            (activeSLABadge.value)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(['cdr-sla-badge', activeSLABadge.value.status])
                                }, [
                                  _cache[79] || (_cache[79] = _createElementVNode("svg", {
                                    width: "10",
                                    height: "10",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("circle", {
                                      cx: "12",
                                      cy: "12",
                                      r: "10"
                                    }),
                                    _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
                                  ], -1)),
                                  _createElementVNode("strong", null, _toDisplayString(activeSLABadge.value.time), 1),
                                  _createElementVNode("span", null, _toDisplayString(activeSLABadge.value.label), 1)
                                ], 2))
                              : _createCommentVNode("", true),
                            (activeConv.value.snoozedUntil)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: "cdr-snooze-tag",
                                  title: `Adiada até ${snoozeUntilLabel.value}`
                                }, [
                                  _cache[80] || (_cache[80] = _createElementVNode("svg", {
                                    width: "10",
                                    height: "10",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("circle", {
                                      cx: "12",
                                      cy: "13",
                                      r: "8"
                                    }),
                                    _createElementVNode("path", { d: "M12 9v4l2 2M5 3 2 6M22 6l-3-3" })
                                  ], -1)),
                                  _createTextVNode(" Adiada · " + _toDisplayString(snoozeLeft.value), 1)
                                ], 8, _hoisted_55))
                              : _createCommentVNode("", true),
                            (activeConv.value.flowName)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(activeConv.value.flowName), 1))
                              : _createCommentVNode("", true),
                            (activeConv.value.bot)
                              ? (_openBlock(), _createBlock(BotVersionTag, {
                                  key: 3,
                                  bot: activeConv.value.bot,
                                  variant: "dark"
                                }, null, 8, ["bot"]))
                              : _createCommentVNode("", true),
                            (activeConv.value.teamName && !_unref(can)('messages.assignTeam'))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_57, [
                                  _cache[81] || (_cache[81] = _createElementVNode("svg", {
                                    width: "9",
                                    height: "9",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
                                    _createElementVNode("circle", {
                                      cx: "9",
                                      cy: "7",
                                      r: "4"
                                    }),
                                    _createElementVNode("path", { d: "M23 21v-2a4 4 0 0 0-3-3.87" }),
                                    _createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
                                  ], -1)),
                                  _createTextVNode(" " + _toDisplayString(activeConv.value.teamName), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (activeConv.value.agentName && !_unref(can)('messages.assignAgent'))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_58, [
                                  _cache[82] || (_cache[82] = _createElementVNode("svg", {
                                    width: "9",
                                    height: "9",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                                    _createElementVNode("circle", {
                                      cx: "12",
                                      cy: "7",
                                      r: "4"
                                    })
                                  ], -1)),
                                  _createTextVNode(" " + _toDisplayString(activeConv.value.agentName), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          (_unref(can)('messages.changeStatus'))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "cdr-status-wrap",
                                onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _createElementVNode("button", {
                                  class: "cdr-icon-btn",
                                  title: `Status: ${_unref(STATUS_LABEL)[activeConv.value.status]}`,
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (cdrStatusMenuOpen.value = !cdrStatusMenuOpen.value))
                                }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["cdr-s-dot", convStatusClass(activeConv.value.status)])
                                  }, null, 2)
                                ], 8, _hoisted_60),
                                (cdrStatusMenuOpen.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                      (activeConv.value.status !== 0)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "cdr-sopt",
                                            onClick: _cache[11] || (_cache[11] = ($event: any) => (cdrChangeStatus('Open')))
                                          }, [...(_cache[83] || (_cache[83] = [
                                            _createElementVNode("span", { class: "cdr-s-dot open" }, null, -1),
                                            _createTextVNode(" Abrir ", -1)
                                          ]))]))
                                        : _createCommentVNode("", true),
                                      (activeConv.value.status !== 2)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: "cdr-sopt",
                                            onClick: cdrResolve
                                          }, [...(_cache[84] || (_cache[84] = [
                                            _createElementVNode("span", { class: "cdr-s-dot resolved" }, null, -1),
                                            _createTextVNode(" Resolver ", -1)
                                          ]))]))
                                        : _createCommentVNode("", true),
                                      (activeConv.value.status !== 1 || activeConv.value.snoozedUntil)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 2,
                                            class: "cdr-sopt",
                                            onClick: _cache[12] || (_cache[12] = ($event: any) => (cdrChangeStatus('Pending')))
                                          }, [...(_cache[85] || (_cache[85] = [
                                            _createElementVNode("span", { class: "cdr-s-dot pending" }, null, -1),
                                            _createTextVNode(" Pendente ", -1)
                                          ]))]))
                                        : _createCommentVNode("", true),
                                      (activeConv.value.status !== 2)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 3,
                                            class: _normalizeClass(["cdr-sopt", { 'is-on': cdrSnoozeOpen.value }]),
                                            onClick: toggleSnoozePicker
                                          }, [
                                            _cache[86] || (_cache[86] = _createElementVNode("span", { class: "cdr-s-dot snoozed" }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(activeConv.value.snoozedUntil ? 'Mudar adiamento…' : 'Adiar…'), 1)
                                          ], 2))
                                        : _createCommentVNode("", true),
                                      (cdrSnoozeOpen.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                            _cache[87] || (_cache[87] = _createElementVNode("span", { class: "cdr-snooze-title" }, "Adiar até", -1)),
                                            _createElementVNode("div", _hoisted_63, [
                                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(SNOOZE_PRESETS, (p) => {
                                                return _createElementVNode("button", {
                                                  key: p.label,
                                                  type: "button",
                                                  disabled: cdrSnoozing.value,
                                                  onClick: ($event: any) => (cdrSnooze(p.at()))
                                                }, _toDisplayString(p.label), 9, _hoisted_64)
                                              }), 64))
                                            ]),
                                            _createElementVNode("label", _hoisted_65, [
                                              _withDirectives(_createElementVNode("input", {
                                                id: "cdr-snooze-at",
                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((cdrSnoozeAt).value = $event)),
                                                type: "datetime-local",
                                                min: snoozeMin.value
                                              }, null, 8, _hoisted_66), [
                                                [_vModelText, cdrSnoozeAt.value]
                                              ]),
                                              _createElementVNode("button", {
                                                type: "button",
                                                disabled: !cdrSnoozeAt.value || cdrSnoozing.value,
                                                onClick: _cache[14] || (_cache[14] = ($event: any) => (cdrSnooze(new Date(cdrSnoozeAt.value))))
                                              }, "Adiar", 8, _hoisted_67)
                                            ]),
                                            (cdrSnoozeError.value)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_68, _toDisplayString(cdrSnoozeError.value), 1))
                                              : _createCommentVNode("", true),
                                            _cache[88] || (_cache[88] = _createElementVNode("p", { class: "cdr-snooze-hint" }, "Quando o prazo chegar, a conversa volta pra Aberta e você recebe um aviso. Se o contato escrever antes, ela reabre na hora.", -1))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "cdr-icon-btn",
                            disabled: cdrExporting.value,
                            title: cdrExporting.value ? 'Exportando…' : 'Exportar conversa',
                            onClick: exportActiveConv
                          }, [
                            (!cdrExporting.value)
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_70, [...(_cache[89] || (_cache[89] = [
                                  _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }, null, -1),
                                  _createElementVNode("polyline", { points: "7 10 12 15 17 10" }, null, -1),
                                  _createElementVNode("line", {
                                    x1: "12",
                                    y1: "15",
                                    x2: "12",
                                    y2: "3"
                                  }, null, -1)
                                ]))]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_71))
                          ], 8, _hoisted_69),
                          _createElementVNode("button", {
                            class: "cdr-icon-btn",
                            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_unref(openMsgSearch) && _unref(openMsgSearch)(...args))),
                            title: "Buscar nas mensagens"
                          }, [...(_cache[90] || (_cache[90] = [
                            _createElementVNode("svg", {
                              width: "12",
                              height: "12",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.8",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("circle", {
                                cx: "11",
                                cy: "11",
                                r: "8"
                              }),
                              _createElementVNode("line", {
                                x1: "21",
                                y1: "21",
                                x2: "16.65",
                                y2: "16.65"
                              })
                            ], -1)
                          ]))]),
                          (_unref(can)('messages.runMacro'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: _normalizeClass(["cdr-icon-btn", { 'cdr-icon-btn--active': cdrMacroPanelOpen.value }]),
                                onClick: toggleCdrMacroPanel,
                                title: cdrMacroPanelOpen.value ? 'Voltar à conversa' : 'Executar macro'
                              }, [
                                (!cdrMacroPanelOpen.value)
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_73, [...(_cache[91] || (_cache[91] = [
                                      _createElementVNode("polygon", { points: "5 3 19 12 5 21 5 3" }, null, -1)
                                    ]))]))
                                  : (_openBlock(), _createElementBlock("svg", _hoisted_74, [...(_cache[92] || (_cache[92] = [
                                      _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" }, null, -1)
                                    ]))]))
                              ], 10, _hoisted_72))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "cdr-icon-btn",
                            onClick: closePanel,
                            title: "Fechar conversa"
                          }, [...(_cache[93] || (_cache[93] = [
                            _createElementVNode("svg", {
                              width: "12",
                              height: "12",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "3",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("line", {
                                x1: "18",
                                y1: "6",
                                x2: "6",
                                y2: "18"
                              }),
                              _createElementVNode("line", {
                                x1: "6",
                                y1: "6",
                                x2: "18",
                                y2: "18"
                              })
                            ], -1)
                          ]))])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        (_unref(can)('messages.assignAgent'))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "cdr-agent-wrap",
                              onClick: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              (activeConv.value.agentName)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "cdr-agent-sel",
                                    onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (agentMenuOpen.value = !agentMenuOpen.value), ["stop"])),
                                    title: "Mudar agente"
                                  }, [
                                    _cache[94] || (_cache[94] = _createElementVNode("svg", {
                                      width: "8",
                                      height: "8",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2.5",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }, [
                                      _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                                      _createElementVNode("circle", {
                                        cx: "12",
                                        cy: "7",
                                        r: "4"
                                      })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(activeConv.value.agentName), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "cdr-lbl-add-btn",
                                    onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (agentMenuOpen.value = !agentMenuOpen.value), ["stop"]))
                                  }, [...(_cache[95] || (_cache[95] = [
                                    _createElementVNode("svg", {
                                      width: "8",
                                      height: "8",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2.5",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }, [
                                      _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                                      _createElementVNode("circle", {
                                        cx: "12",
                                        cy: "7",
                                        r: "4"
                                      })
                                    ], -1),
                                    _createTextVNode(" agente ", -1)
                                  ]))])),
                              (agentMenuOpen.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                    _createElementVNode("div", _hoisted_77, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((agentSearch).value = $event)),
                                        class: "cdr-agent-search",
                                        placeholder: "Buscar agente…",
                                        onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"])),
                                        onKeydown: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"]))
                                      }, null, 544), [
                                        [_vModelText, agentSearch.value]
                                      ])
                                    ]),
                                    (agentLoading.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [...(_cache[96] || (_cache[96] = [
                                          _createElementVNode("div", {
                                            class: "cdr-spinner",
                                            style: {"width":"14px","height":"14px","border-width":"2px"}
                                          }, null, -1)
                                        ]))]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAgents.value, (a) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                              key: a.id,
                                              class: _normalizeClass(["cdr-agent-opt", { active: activeConv.value.agentId === a.id }]),
                                              onClick: _withModifiers(($event: any) => (doAssignAgent(a.id)), ["stop"])
                                            }, [
                                              _createElementVNode("div", _hoisted_81, [
                                                _createElementVNode("div", {
                                                  class: "cdr-agent-av",
                                                  style: _normalizeStyle({ background: _unref(avatarColor)(a.firstName + ' ' + a.lastName), overflow:'hidden' })
                                                }, [
                                                  (a.avatarUrl)
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: _unref(toMediaUrl)(a.avatarUrl),
                                                        alt: a.firstName,
                                                        style: {"width":"100%","height":"100%","object-fit":"cover","border-radius":"50%","display":"block"},
                                                        onError: _cache[22] || (_cache[22] = (e) => (e.target as HTMLImageElement).style.display='none')
                                                      }, null, 40, _hoisted_82))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(_unref(initials)(a.firstName + ' ' + a.lastName)), 1))
                                                ], 4),
                                                _createElementVNode("span", {
                                                  class: _normalizeClass(["cdr-agent-status-dot", `casd-${a.status.toLowerCase()}`])
                                                }, null, 2)
                                              ]),
                                              _createTextVNode(" " + _toDisplayString(a.firstName) + " " + _toDisplayString(a.lastName) + " ", 1),
                                              (activeConv.value.agentId === a.id)
                                                ? (_openBlock(), _createElementBlock("svg", _hoisted_84, [...(_cache[97] || (_cache[97] = [
                                                    _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                                  ]))]))
                                                : _createCommentVNode("", true)
                                            ], 10, _hoisted_80))
                                          }), 128))
                                        ]))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(can)('messages.assignTeam'))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "cdr-agent-wrap",
                              onClick: _cache[29] || (_cache[29] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              (activeConv.value.teamName)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "cdr-agent-sel",
                                    onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (cdrTeamMenuOpen.value = !cdrTeamMenuOpen.value), ["stop"])),
                                    title: "Mudar time"
                                  }, [
                                    _cache[98] || (_cache[98] = _createElementVNode("svg", {
                                      width: "8",
                                      height: "8",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2.5",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }, [
                                      _createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
                                      _createElementVNode("circle", {
                                        cx: "9",
                                        cy: "7",
                                        r: "4"
                                      }),
                                      _createElementVNode("path", { d: "M23 21v-2a4 4 0 0 0-3-3.87" }),
                                      _createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(activeConv.value.teamName), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "cdr-lbl-add-btn",
                                    onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (cdrTeamMenuOpen.value = !cdrTeamMenuOpen.value), ["stop"]))
                                  }, [...(_cache[99] || (_cache[99] = [
                                    _createElementVNode("svg", {
                                      width: "8",
                                      height: "8",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2.5",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }, [
                                      _createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
                                      _createElementVNode("circle", {
                                        cx: "9",
                                        cy: "7",
                                        r: "4"
                                      }),
                                      _createElementVNode("path", { d: "M23 21v-2a4 4 0 0 0-3-3.87" }),
                                      _createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
                                    ], -1),
                                    _createTextVNode(" time ", -1)
                                  ]))])),
                              (cdrTeamMenuOpen.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                    _createElementVNode("div", _hoisted_86, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((cdrTeamSearch).value = $event)),
                                        class: "cdr-agent-search",
                                        placeholder: "Buscar time…",
                                        onClick: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["stop"])),
                                        onKeydown: _cache[28] || (_cache[28] = _withModifiers(() => {}, ["stop"]))
                                      }, null, 544), [
                                        [_vModelText, cdrTeamSearch.value]
                                      ])
                                    ]),
                                    (cdrTeamsLoading.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_87, [...(_cache[100] || (_cache[100] = [
                                          _createElementVNode("div", {
                                            class: "cdr-spinner",
                                            style: {"width":"14px","height":"14px","border-width":"2px"}
                                          }, null, -1)
                                        ]))]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCdrTeams.value, (t) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                              key: t.id,
                                              class: _normalizeClass(["cdr-agent-opt", { active: activeConv.value.teamId === t.id }]),
                                              onClick: _withModifiers(($event: any) => (doAssignCdrTeam(t.id)), ["stop"])
                                            }, [
                                              _createElementVNode("div", {
                                                class: "cdr-agent-av",
                                                style: _normalizeStyle({ background: _unref(avatarColor)(t.name) })
                                              }, _toDisplayString(_unref(initials)(t.name)), 5),
                                              _createTextVNode(" " + _toDisplayString(t.name) + " ", 1),
                                              (activeConv.value.teamId === t.id)
                                                ? (_openBlock(), _createElementBlock("svg", _hoisted_90, [...(_cache[101] || (_cache[101] = [
                                                    _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                                  ]))]))
                                                : _createCommentVNode("", true)
                                            ], 10, _hoisted_89))
                                          }), 128))
                                        ]))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeConv.value.tagNames, (l) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: l,
                            class: "cdr-lbl cdr-lbl-active"
                          }, [
                            _createTextVNode(_toDisplayString(l) + " ", 1),
                            (!isTagProtected(l))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "cdr-lbl-x",
                                  onClick: _withModifiers(($event: any) => (toggleTag(l)), ["stop"]),
                                  disabled: updatingLabels.value
                                }, "×", 8, _hoisted_91))
                              : (_openBlock(), _createElementBlock("svg", _hoisted_92, [...(_cache[102] || (_cache[102] = [
                                  _createElementVNode("rect", {
                                    x: "3",
                                    y: "11",
                                    width: "18",
                                    height: "11",
                                    rx: "2"
                                  }, null, -1),
                                  _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" }, null, -1)
                                ]))]))
                          ]))
                        }), 128)),
                        (_unref(can)('messages.manageTags'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                              _createElementVNode("button", {
                                class: "cdr-lbl-add-btn",
                                onClick: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (labelsOpen.value = !labelsOpen.value), ["stop"])),
                                disabled: updatingLabels.value
                              }, [...(_cache[103] || (_cache[103] = [
                                _createElementVNode("svg", {
                                  width: "9",
                                  height: "9",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "3.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }, [
                                  _createElementVNode("line", {
                                    x1: "12",
                                    y1: "5",
                                    x2: "12",
                                    y2: "19"
                                  }),
                                  _createElementVNode("line", {
                                    x1: "5",
                                    y1: "12",
                                    x2: "19",
                                    y2: "12"
                                  })
                                ], -1),
                                _createTextVNode(" etiqueta ", -1)
                              ]))], 8, _hoisted_94),
                              (labelsOpen.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                    (!allTags.value.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_96, [...(_cache[104] || (_cache[104] = [
                                          _createElementVNode("span", {
                                            class: "cdr-spinner",
                                            style: {"width":"14px","height":"14px","border-width":"2px"}
                                          }, null, -1)
                                        ]))]))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allTags.value, (tag) => {
                                      return (_openBlock(), _createElementBlock("label", {
                                        key: tag.id,
                                        class: _normalizeClass(["cdr-lbl-opt", { checked: activeConv.value.tagNames.includes(tag.name) }]),
                                        onClick: _withModifiers(($event: any) => ((activeConv.value.tagNames.includes(tag.name) && tag.isProtected) || toggleTag(tag.name)), ["prevent"])
                                      }, [
                                        _createElementVNode("span", {
                                          class: "cdr-lbl-dot",
                                          style: _normalizeStyle({ background: tag.color })
                                        }, null, 4),
                                        _createElementVNode("span", _hoisted_98, _toDisplayString(tag.name), 1),
                                        (activeConv.value.tagNames.includes(tag.name) && tag.isProtected)
                                          ? (_openBlock(), _createElementBlock("svg", _hoisted_99, [...(_cache[105] || (_cache[105] = [
                                              _createElementVNode("rect", {
                                                x: "3",
                                                y: "11",
                                                width: "18",
                                                height: "11",
                                                rx: "2"
                                              }, null, -1),
                                              _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" }, null, -1)
                                            ]))]))
                                          : (activeConv.value.tagNames.includes(tag.name))
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_100, [...(_cache[106] || (_cache[106] = [
                                                _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                              ]))]))
                                            : _createCommentVNode("", true)
                                      ], 10, _hoisted_97))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (iAmObserver.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_101, [...(_cache[107] || (_cache[107] = [
                            _createElementVNode("svg", {
                              width: "13",
                              height: "13",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }),
                              _createElementVNode("circle", {
                                cx: "12",
                                cy: "12",
                                r: "3"
                              })
                            ], -1),
                            _createElementVNode("span", null, "Modo observador: você só acompanha. Mensagem pro contato não sai — nota interna pode.", -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      (_unref(cdrWindowClosed))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_102, [...(_cache[108] || (_cache[108] = [
                            _createElementVNode("svg", {
                              width: "13",
                              height: "13",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("circle", {
                                cx: "12",
                                cy: "12",
                                r: "10"
                              }),
                              _createElementVNode("line", {
                                x1: "12",
                                y1: "8",
                                x2: "12",
                                y2: "12"
                              }),
                              _createElementVNode("line", {
                                x1: "12",
                                y1: "16",
                                x2: "12.01",
                                y2: "16"
                              })
                            ], -1),
                            _createElementVNode("span", null, "Você só pode responder usando um template — janela de 24h do WhatsApp encerrada", -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      (_unref(msgSearchOpen))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                            _withDirectives(_createElementVNode("input", {
                              ref_key: "msgSearchInputEl",
                              ref: msgSearchInputEl,
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_isRef(msgSearchQuery) ? (msgSearchQuery).value = $event : null)),
                              class: "cdr-msg-search-input",
                              placeholder: "Buscar nas mensagens…",
                              onKeydown: [
                                _cache[32] || (_cache[32] = _withKeys(
//@ts-ignore
(...args) => (_unref(doMsgSearch) && _unref(doMsgSearch)(...args)), ["enter"])),
                                _cache[33] || (_cache[33] = _withKeys(
//@ts-ignore
(...args) => (_unref(closeMsgSearch) && _unref(closeMsgSearch)(...args)), ["escape"]))
                              ]
                            }, null, 544), [
                              [_vModelText, _unref(msgSearchQuery)]
                            ]),
                            (_unref(msgSearchActive))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_104, _toDisplayString(_unref(msgMatchIds).length ? (_unref(msgCurrentIdx) + 1) + '/' + _unref(msgMatchIds).length : '0 resultados'), 1))
                              : _createCommentVNode("", true),
                            (_unref(msgMatchIds).length)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "cdr-msg-search-nav",
                                  onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_unref(goPrevMsg) && _unref(goPrevMsg)(...args))),
                                  title: "Anterior"
                                }, [...(_cache[109] || (_cache[109] = [
                                  _createElementVNode("svg", {
                                    width: "10",
                                    height: "10",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("polyline", { points: "18 15 12 9 6 15" })
                                  ], -1)
                                ]))]))
                              : _createCommentVNode("", true),
                            (_unref(msgMatchIds).length)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  class: "cdr-msg-search-nav",
                                  onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_unref(goNextMsg) && _unref(goNextMsg)(...args))),
                                  title: "Próximo"
                                }, [...(_cache[110] || (_cache[110] = [
                                  _createElementVNode("svg", {
                                    width: "10",
                                    height: "10",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("polyline", { points: "6 9 12 15 18 9" })
                                  ], -1)
                                ]))]))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              class: "cdr-msg-search-close",
                              onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_unref(closeMsgSearch) && _unref(closeMsgSearch)(...args)))
                            }, [...(_cache[111] || (_cache[111] = [
                              _createElementVNode("svg", {
                                width: "10",
                                height: "10",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("line", {
                                  x1: "18",
                                  y1: "6",
                                  x2: "6",
                                  y2: "18"
                                }),
                                _createElementVNode("line", {
                                  x1: "6",
                                  y1: "6",
                                  x2: "18",
                                  y2: "18"
                                })
                              ], -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (cdrMacroPanelOpen.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                            (cdrMacroFormTarget.value && !cdrMacroRunning.value && !cdrMacroRunDone.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("div", _hoisted_106, [
                                    _createElementVNode("button", {
                                      class: "cdr-macro-back",
                                      onClick: _cache[37] || (_cache[37] = ($event: any) => (cdrMacroFormTarget.value = null))
                                    }, [...(_cache[112] || (_cache[112] = [
                                      _createElementVNode("svg", {
                                        width: "11",
                                        height: "11",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2.5",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round"
                                      }, [
                                        _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
                                      ], -1),
                                      _createTextVNode(" Voltar ", -1)
                                    ]))]),
                                    _createElementVNode("span", _hoisted_107, _toDisplayString(cdrMacroFormTarget.value.name), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_108, [
                                    _createElementVNode("div", _hoisted_109, [
                                      _cache[113] || (_cache[113] = _createElementVNode("p", { class: "cdr-mform-hint" }, "Preencha os campos antes de executar", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cdrMacroFormFields.value, (field) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: field.key,
                                          class: "cdr-mform-field"
                                        }, [
                                          _createElementVNode("label", _hoisted_110, _toDisplayString(field.label || field.key), 1),
                                          _withDirectives(_createElementVNode("input", {
                                            class: "cdr-mform-input",
                                            "onUpdate:modelValue": ($event: any) => ((cdrMacroFormValues.value[field.key]) = $event),
                                            placeholder: field.label || field.key,
                                            type: "text"
                                          }, null, 8, _hoisted_111), [
                                            [_vModelText, cdrMacroFormValues.value[field.key]]
                                          ])
                                        ]))
                                      }), 128))
                                    ]),
                                    _createElementVNode("div", { class: "cdr-mform-btns" }, [
                                      _createElementVNode("button", {
                                        class: "cdr-mform-submit",
                                        onClick: submitCdrMacroForm
                                      }, [...(_cache[114] || (_cache[114] = [
                                        _createElementVNode("svg", {
                                          width: "11",
                                          height: "11",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2.5",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        }, [
                                          _createElementVNode("polygon", { points: "5 3 19 12 5 21 5 3" })
                                        ], -1),
                                        _createTextVNode(" Executar ", -1)
                                      ]))])
                                    ])
                                  ])
                                ], 64))
                              : (!cdrMacroRunning.value && !cdrMacroRunDone.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("div", _hoisted_112, [
                                      _createElementVNode("div", _hoisted_113, [
                                        _cache[115] || (_cache[115] = _createElementVNode("svg", {
                                          width: "11",
                                          height: "11",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2.5",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        }, [
                                          _createElementVNode("circle", {
                                            cx: "11",
                                            cy: "11",
                                            r: "8"
                                          }),
                                          _createElementVNode("line", {
                                            x1: "21",
                                            y1: "21",
                                            x2: "16.65",
                                            y2: "16.65"
                                          })
                                        ], -1)),
                                        _withDirectives(_createElementVNode("input", {
                                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((cdrMacroSearch).value = $event)),
                                          class: "cdr-macro-search",
                                          placeholder: "Buscar macro…"
                                        }, null, 512), [
                                          [_vModelText, cdrMacroSearch.value]
                                        ])
                                      ]),
                                      _createElementVNode("span", _hoisted_114, _toDisplayString(cdrFilteredMacros.value.length) + " macro" + _toDisplayString(cdrFilteredMacros.value.length !== 1 ? 's' : ''), 1)
                                    ]),
                                    (cdrMacrosLoading.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_115, [...(_cache[116] || (_cache[116] = [
                                          _createElementVNode("span", { class: "cdr-spinner" }, null, -1)
                                        ]))]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cdrFilteredMacros.value, (m) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                              key: m.id,
                                              class: "cdr-macro-item",
                                              onClick: ($event: any) => (runCdrMacro(m))
                                            }, [
                                              _createElementVNode("div", _hoisted_118, [
                                                _createElementVNode("span", _hoisted_119, _toDisplayString(m.name), 1),
                                                _createElementVNode("span", _hoisted_120, _toDisplayString(m.actions.length) + " ação" + _toDisplayString(m.actions.length !== 1 ? 'ões' : ''), 1)
                                              ]),
                                              _cache[117] || (_cache[117] = _createElementVNode("svg", {
                                                width: "11",
                                                height: "11",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                "stroke-width": "2.5",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round"
                                              }, [
                                                _createElementVNode("polygon", { points: "5 3 19 12 5 21 5 3" })
                                              ], -1))
                                            ], 8, _hoisted_117))
                                          }), 128)),
                                          (!cdrFilteredMacros.value.length && !cdrMacrosLoading.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_121, "Nenhuma macro encontrada"))
                                            : _createCommentVNode("", true)
                                        ]))
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createElementVNode("div", _hoisted_122, [
                                      (cdrMacroRunDone.value)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "cdr-macro-back",
                                            onClick: resetCdrMacroRun
                                          }, [...(_cache[118] || (_cache[118] = [
                                            _createElementVNode("svg", {
                                              width: "11",
                                              height: "11",
                                              viewBox: "0 0 24 24",
                                              fill: "none",
                                              stroke: "currentColor",
                                              "stroke-width": "2.5",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round"
                                            }, [
                                              _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
                                            ], -1),
                                            _createTextVNode(" Voltar ", -1)
                                          ]))]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("span", _hoisted_123, _toDisplayString(cdrMacroRunningObj.value?.name), 1),
                                      (cdrMacroRunning.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_124))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (cdrMacroRunDone.value)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: _normalizeClass(["cdr-macro-summary", cdrMacroResult.value?.success ? 'cdr-macro-summary--ok' : 'cdr-macro-summary--warn'])
                                        }, [
                                          (cdrMacroResult.value?.success)
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_125, [...(_cache[119] || (_cache[119] = [
                                                _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                              ]))]))
                                            : (_openBlock(), _createElementBlock("svg", _hoisted_126, [...(_cache[120] || (_cache[120] = [
                                                _createElementVNode("circle", {
                                                  cx: "12",
                                                  cy: "12",
                                                  r: "10"
                                                }, null, -1),
                                                _createElementVNode("line", {
                                                  x1: "12",
                                                  y1: "8",
                                                  x2: "12",
                                                  y2: "12"
                                                }, null, -1),
                                                _createElementVNode("line", {
                                                  x1: "12",
                                                  y1: "16",
                                                  x2: "12.01",
                                                  y2: "16"
                                                }, null, -1)
                                              ]))])),
                                          _createTextVNode(" " + _toDisplayString(cdrMacroResult.value?.success ? `Concluído — ${cdrMacroResult.value.actionsApplied} ação(ões) aplicada(s)` : `Falhou: ${cdrMacroResult.value?.failureReason}`), 1)
                                        ], 2))
                                      : _createCommentVNode("", true)
                                  ], 64))
                          ]))
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("div", {
                        class: "cdr-msgs",
                        ref_key: "msgsEl",
                        ref: msgsEl,
                        onScroll: onMsgsScroll
                      }, [
                        (loadingMsgs.value || _unref(msgSearchLoading))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                              (_unref(msgSearchLoading))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[121] || (_cache[121] = _createElementVNode("span", { class: "cdr-spinner" }, null, -1)),
                                    _cache[122] || (_cache[122] = _createElementVNode("span", { class: "cdr-msgs-loading-label" }, "Buscando em toda a conversa…", -1))
                                  ], 64))
                                : (_openBlock(), _createElementBlock("div", _hoisted_128, [...(_cache[123] || (_cache[123] = [
                                    _createElementVNode("div", { class: "cdr-sk-row inn" }, [
                                      _createElementVNode("div", {
                                        class: "cdr-sk-bubble",
                                        style: {"width":"58%"}
                                      })
                                    ], -1),
                                    _createElementVNode("div", { class: "cdr-sk-row inn" }, [
                                      _createElementVNode("div", {
                                        class: "cdr-sk-bubble",
                                        style: {"width":"36%"}
                                      })
                                    ], -1),
                                    _createElementVNode("div", { class: "cdr-sk-row out" }, [
                                      _createElementVNode("div", {
                                        class: "cdr-sk-bubble",
                                        style: {"width":"46%"}
                                      })
                                    ], -1),
                                    _createElementVNode("div", { class: "cdr-sk-row inn" }, [
                                      _createElementVNode("div", {
                                        class: "cdr-sk-bubble",
                                        style: {"width":"64%"}
                                      })
                                    ], -1),
                                    _createElementVNode("div", { class: "cdr-sk-row out" }, [
                                      _createElementVNode("div", {
                                        class: "cdr-sk-bubble",
                                        style: {"width":"30%"}
                                      })
                                    ], -1)
                                  ]))]))
                            ]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (loadingMore.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_129, [...(_cache[124] || (_cache[124] = [
                                    _createElementVNode("span", { class: "cdr-spinner-sm" }, null, -1)
                                  ]))]))
                                : (noMoreMsgs.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_130, "início da conversa"))
                                  : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedMsgs.value, (msg) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: msg.id,
                                  class: _normalizeClass(["cdr-msg-row", { out: msg.senderType === 'Agent', inn: msg.senderType === 'Contact' || msg.senderType === 'Bot', act: msg.senderType === 'System', 'msg-match-current': _unref(msgSearchActive) && _unref(msgMatchIds)[_unref(msgCurrentIdx)] === msg.id }]),
                                  "data-msg-id": msg.id
                                }, [
                                  (msg.senderType === 'System')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_132, _toDisplayString(msg.body), 1))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (msg.showAvatar)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "cdr-msg-av",
                                              style: _normalizeStyle({ background: msgSender(msg).color }),
                                              title: msgSender(msg).name
                                            }, [
                                              (msgSender(msg).avatarUrl)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: msgSender(msg).avatarUrl!,
                                                    alt: msgSender(msg).name,
                                                    onError: _cache[39] || (_cache[39] = (e) => (e.target as HTMLImageElement).style.display = 'none')
                                                  }, null, 40, _hoisted_134))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_135, _toDisplayString(msgSender(msg).initials), 1))
                                            ], 12, _hoisted_133))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_136)),
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["cdr-bubble", { 'cdr-bubble--priv': msg.isPrivateNote }])
                                        }, [
                                          (msg.isPrivateNote)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_137, [...(_cache[125] || (_cache[125] = [
                                                _createElementVNode("svg", {
                                                  width: "10",
                                                  height: "10",
                                                  viewBox: "0 0 24 24",
                                                  fill: "none",
                                                  stroke: "currentColor",
                                                  "stroke-width": "2.5",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round"
                                                }, [
                                                  _createElementVNode("rect", {
                                                    x: "3",
                                                    y: "11",
                                                    width: "18",
                                                    height: "11",
                                                    rx: "2"
                                                  }),
                                                  _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
                                                ], -1),
                                                _createTextVNode(" Nota interna ", -1)
                                              ]))]))
                                            : _createCommentVNode("", true),
                                          (msg.body)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 1,
                                                class: "cdr-bubble-text",
                                                innerHTML: _unref(highlightMsgHtml)(msg.body)
                                              }, null, 8, _hoisted_138))
                                            : _createCommentVNode("", true),
                                          (msg.mediaUrl)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                                                (isImageMime(msg.mediaMimeType))
                                                  ? (_openBlock(), _createElementBlock("a", {
                                                      key: 0,
                                                      href: _unref(toMediaUrl)(msg.mediaUrl),
                                                      target: "_blank",
                                                      rel: "noopener",
                                                      class: "cdr-att-img-wrap"
                                                    }, [
                                                      _createElementVNode("img", {
                                                        src: _unref(toMediaUrl)(msg.mediaUrl),
                                                        class: "cdr-att-img",
                                                        alt: "imagem",
                                                        loading: "lazy"
                                                      }, null, 8, _hoisted_141)
                                                    ], 8, _hoisted_140))
                                                  : (isAudioMime(msg.mediaMimeType))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                                                        _createElementVNode("button", {
                                                          class: "cdr-ap-btn",
                                                          onClick: ($event: any) => (_unref(toggleAudio)({ id: msg.id, dataUrl: _unref(toMediaUrl)(msg.mediaUrl) }))
                                                        }, [
                                                          (_unref(audioState)[msg.id]?.playing)
                                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_144, [...(_cache[126] || (_cache[126] = [
                                                                _createElementVNode("rect", {
                                                                  x: "6",
                                                                  y: "4",
                                                                  width: "4",
                                                                  height: "16"
                                                                }, null, -1),
                                                                _createElementVNode("rect", {
                                                                  x: "14",
                                                                  y: "4",
                                                                  width: "4",
                                                                  height: "16"
                                                                }, null, -1)
                                                              ]))]))
                                                            : (_openBlock(), _createElementBlock("svg", _hoisted_145, [...(_cache[127] || (_cache[127] = [
                                                                _createElementVNode("polygon", { points: "5 3 19 12 5 21 5 3" }, null, -1)
                                                              ]))]))
                                                        ], 8, _hoisted_143),
                                                        _createElementVNode("div", _hoisted_146, [
                                                          _createElementVNode("div", {
                                                            class: "cdr-ap-bar",
                                                            onClick: _cache[40] || (_cache[40] = _withModifiers(() => {}, ["stop"]))
                                                          }, [
                                                            _createElementVNode("div", {
                                                              class: "cdr-ap-fill",
                                                              style: _normalizeStyle({ width: _unref(audioProgress)(msg.id) + '%' })
                                                            }, null, 4),
                                                            _createElementVNode("input", {
                                                              type: "range",
                                                              class: "cdr-ap-seek",
                                                              min: "0",
                                                              max: "100",
                                                              step: "0.1",
                                                              value: _unref(audioProgress)(msg.id),
                                                              onInput: ($event: any) => (_unref(seekAudio)({ id: msg.id, dataUrl: _unref(toMediaUrl)(msg.mediaUrl) }, $event))
                                                            }, null, 40, _hoisted_147)
                                                          ]),
                                                          _createElementVNode("div", _hoisted_148, [
                                                            _createElementVNode("span", null, _toDisplayString(_unref(fmtTime)(_unref(audioState)[msg.id]?.current || 0)), 1),
                                                            _createElementVNode("span", null, _toDisplayString(_unref(fmtTime)(_unref(audioState)[msg.id]?.duration || 0)), 1)
                                                          ])
                                                        ]),
                                                        _createElementVNode("a", {
                                                          href: _unref(toMediaUrl)(msg.mediaUrl),
                                                          target: "_blank",
                                                          rel: "noopener",
                                                          class: "cdr-ap-dl",
                                                          title: "Baixar"
                                                        }, [...(_cache[128] || (_cache[128] = [
                                                          _createElementVNode("svg", {
                                                            width: "13",
                                                            height: "13",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            "stroke-width": "2.5",
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round"
                                                          }, [
                                                            _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
                                                            _createElementVNode("polyline", { points: "7 10 12 15 17 10" }),
                                                            _createElementVNode("line", {
                                                              x1: "12",
                                                              y1: "15",
                                                              x2: "12",
                                                              y2: "3"
                                                            })
                                                          ], -1)
                                                        ]))], 8, _hoisted_149)
                                                      ]))
                                                    : (isVideoMime(msg.mediaMimeType))
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                                                          _createElementVNode("video", {
                                                            src: _unref(toMediaUrl)(msg.mediaUrl),
                                                            controls: "",
                                                            preload: "metadata",
                                                            class: "cdr-att-video"
                                                          }, null, 8, _hoisted_151)
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("a", {
                                                          key: 3,
                                                          href: _unref(toMediaUrl)(msg.mediaUrl),
                                                          target: "_blank",
                                                          rel: "noopener",
                                                          class: _normalizeClass(["cdr-att-file", { 'cdr-att-pdf': isPdfMime(msg.mediaMimeType) }])
                                                        }, [
                                                          _cache[129] || (_cache[129] = _createElementVNode("svg", {
                                                            width: "18",
                                                            height: "18",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            "stroke-width": "1.8",
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round"
                                                          }, [
                                                            _createElementVNode("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
                                                            _createElementVNode("polyline", { points: "14 2 14 8 20 8" })
                                                          ], -1)),
                                                          _createElementVNode("div", _hoisted_153, [
                                                            _createElementVNode("span", _hoisted_154, _toDisplayString(isPdfMime(msg.mediaMimeType) ? 'PDF' : 'Arquivo'), 1)
                                                          ]),
                                                          _cache[130] || (_cache[130] = _createElementVNode("svg", {
                                                            width: "13",
                                                            height: "13",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            "stroke-width": "2.5",
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round"
                                                          }, [
                                                            _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
                                                            _createElementVNode("polyline", { points: "7 10 12 15 17 10" }),
                                                            _createElementVNode("line", {
                                                              x1: "12",
                                                              y1: "15",
                                                              x2: "12",
                                                              y2: "3"
                                                            })
                                                          ], -1))
                                                        ], 10, _hoisted_152))
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("span", _hoisted_155, [
                                            (msg.origin === 'copilot')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_156, "IA"))
                                              : _createCommentVNode("", true),
                                            _createTextVNode(_toDisplayString(fmtTs(msg.createdAt)), 1),
                                            (msg.senderType !== 'Contact' && !msg.isPrivateNote)
                                              ? (_openBlock(), _createBlock(MessageTicks, {
                                                  key: 1,
                                                  status: msg.deliveryStatus,
                                                  error: msg.deliveryError
                                                }, null, 8, ["status", "error"]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ], 2)
                                      ], 64))
                                ], 10, _hoisted_131))
                              }), 128))
                            ], 64))
                      ], 544), [
                        [_vShow, !cdrMacroPanelOpen.value]
                      ]),
                      (files.value.length && !cdrMacroPanelOpen.value && !cdrFinished.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (f, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: "cdr-file-pill"
                              }, [
                                _cache[131] || (_cache[131] = _createElementVNode("svg", {
                                  width: "10",
                                  height: "10",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }, [
                                  _createElementVNode("path", { d: "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" })
                                ], -1)),
                                _createElementVNode("span", _hoisted_158, _toDisplayString(f.name), 1),
                                _createElementVNode("button", {
                                  class: "cdr-file-rm",
                                  onClick: ($event: any) => (files.value.splice(i, 1))
                                }, "×", 8, _hoisted_159)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (selConvId.value && !cdrFinished.value)
                        ? (_openBlock(), _createBlock(CopilotBar, {
                            key: 5,
                            ref_key: "copilotBar",
                            ref: copilotBar,
                            "conversation-id": selConvId.value,
                            draft: draft.value,
                            onFill: fillFromCopilot
                          }, null, 8, ["conversation-id", "draft"]))
                        : _createCommentVNode("", true),
                      (cdrFinished.value && !cdrMacroPanelOpen.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                            _cache[132] || (_cache[132] = _createElementVNode("svg", {
                              width: "15",
                              height: "15",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "aria-hidden": "true"
                            }, [
                              _createElementVNode("rect", {
                                x: "3",
                                y: "11",
                                width: "18",
                                height: "11",
                                rx: "2"
                              }),
                              _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
                            ], -1)),
                            _createElementVNode("span", null, "Conversa " + _toDisplayString(activeConv.value?.status === 3 ? 'fechada' : 'resolvida') + ": não dá pra enviar mensagem, anexo nem template.", 1),
                            (_unref(can)('messages.changeStatus'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "cdr-finished-btn",
                                  onClick: _cache[41] || (_cache[41] = ($event: any) => (cdrChangeStatus('Open')))
                                }, "Reabrir"))
                              : _createCommentVNode("", true)
                          ]))
                        : (!_unref(recording) && !_unref(recordedBlob) && !videoRecording.value && !videoRecordedBlob.value && !cdrMacroPanelOpen.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 7,
                              class: _normalizeClass(["cdr-composer", { 'cdr-composer--priv': notaInterna.value }])
                            }, [
                              _createElementVNode("label", {
                                class: _normalizeClass(["cdr-attach-btn", { 'cdr-attach-disabled': _unref(cdrWindowClosed) || notaInterna.value }]),
                                title: "Anexar arquivo"
                              }, [
                                _createElementVNode("input", {
                                  type: "file",
                                  multiple: "",
                                  hidden: "",
                                  ref_key: "fileInputEl",
                                  ref: fileInputEl,
                                  disabled: _unref(cdrWindowClosed) || notaInterna.value,
                                  onChange: onFilePick
                                }, null, 40, _hoisted_161),
                                _cache[133] || (_cache[133] = _createElementVNode("svg", {
                                  width: "15",
                                  height: "15",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }, [
                                  _createElementVNode("path", { d: "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" })
                                ], -1))
                              ], 2),
                              (_unref(can)('messages.privateNote'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: _normalizeClass(["cdr-priv-btn", { 'cdr-priv-btn--active': notaInterna.value }]),
                                    disabled: _unref(cdrWindowClosed),
                                    onClick: _cache[42] || (_cache[42] = ($event: any) => (notaInterna.value = !notaInterna.value)),
                                    title: notaInterna.value ? 'Nota interna ativada — clique para voltar ao modo normal' : 'Marcar como nota interna (não visível pro cliente)'
                                  }, [...(_cache[134] || (_cache[134] = [
                                    _createElementVNode("svg", {
                                      width: "14",
                                      height: "14",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2.2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }, [
                                      _createElementVNode("rect", {
                                        x: "3",
                                        y: "11",
                                        width: "18",
                                        height: "11",
                                        rx: "2"
                                      }),
                                      _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
                                    ], -1)
                                  ]))], 10, _hoisted_162))
                                : _createCommentVNode("", true),
                              (!_unref(cdrWindowClosed))
                                ? (_openBlock(), _createBlock(EmojiPicker, {
                                    key: 1,
                                    onPick: insertEmoji
                                  }))
                                : _createCommentVNode("", true),
                              _withDirectives(_createElementVNode("textarea", {
                                ref_key: "taEl",
                                ref: taEl,
                                "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((draft).value = $event)),
                                class: "cdr-ta",
                                placeholder: notaInterna.value ? 'Nota interna — só a equipe vê… (Enter envia)' : (_unref(cdrWindowClosed) ? 'Envie um template para responder…' : 'Mensagem… (Enter envia)'),
                                disabled: _unref(cdrWindowClosed),
                                rows: "1",
                                onKeydown: _withKeys(_withModifiers(sendMsg, ["exact","prevent"]), ["enter"]),
                                onInput: _cache[44] || (_cache[44] = ($event: any) => {growTa(); _unref(presence).typing(selConvId.value, notaInterna.value)})
                              }, null, 40, _hoisted_163), [
                                [_vModelText, draft.value]
                              ]),
                              (!notaInterna.value && (_unref(cdrWindowClosed) || (!canSend.value && !sending.value)))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    (_unref(can)('messages.sendTemplate'))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "cdr-wa-tpl-btn",
                                          onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_unref(openCdrTplModal) && _unref(openCdrTplModal)(...args))),
                                          title: "Enviar template WhatsApp"
                                        }, [...(_cache[135] || (_cache[135] = [
                                          _createElementVNode("svg", {
                                            width: "15",
                                            height: "15",
                                            viewBox: "0 0 24 24",
                                            fill: "currentColor"
                                          }, [
                                            _createElementVNode("path", { d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zm-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884zm8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" })
                                          ], -1)
                                        ]))]))
                                      : _createCommentVNode("", true),
                                    (!_unref(cdrWindowClosed))
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createElementVNode("button", {
                                            class: "cdr-mic-btn",
                                            onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_unref(startRecording) && _unref(startRecording)(...args))),
                                            title: "Gravar áudio"
                                          }, [...(_cache[136] || (_cache[136] = [
                                            _createElementVNode("svg", {
                                              width: "14",
                                              height: "14",
                                              viewBox: "0 0 24 24",
                                              fill: "none",
                                              stroke: "currentColor",
                                              "stroke-width": "2.2",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round"
                                            }, [
                                              _createElementVNode("path", { d: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" }),
                                              _createElementVNode("path", { d: "M19 10v2a7 7 0 0 1-14 0v-2" }),
                                              _createElementVNode("line", {
                                                x1: "12",
                                                y1: "19",
                                                x2: "12",
                                                y2: "23"
                                              }),
                                              _createElementVNode("line", {
                                                x1: "8",
                                                y1: "23",
                                                x2: "16",
                                                y2: "23"
                                              })
                                            ], -1)
                                          ]))]),
                                          _createElementVNode("button", {
                                            class: "cdr-mic-btn",
                                            onClick: startVideoRecording,
                                            title: "Gravar vídeo"
                                          }, [...(_cache[137] || (_cache[137] = [
                                            _createElementVNode("svg", {
                                              width: "14",
                                              height: "14",
                                              viewBox: "0 0 24 24",
                                              fill: "none",
                                              stroke: "currentColor",
                                              "stroke-width": "2",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round"
                                            }, [
                                              _createElementVNode("polygon", { points: "23 7 16 12 23 17 23 7" }),
                                              _createElementVNode("rect", {
                                                x: "1",
                                                y: "5",
                                                width: "15",
                                                height: "14",
                                                rx: "2",
                                                ry: "2"
                                              })
                                            ], -1)
                                          ]))])
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 3,
                                    class: "cdr-send-btn",
                                    onClick: sendMsg,
                                    disabled: !canSend.value || sending.value
                                  }, [
                                    (sending.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_165))
                                      : (_openBlock(), _createElementBlock("svg", _hoisted_166, [...(_cache[138] || (_cache[138] = [
                                          _createElementVNode("line", {
                                            x1: "22",
                                            y1: "2",
                                            x2: "11",
                                            y2: "13"
                                          }, null, -1),
                                          _createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" }, null, -1)
                                        ]))]))
                                  ], 8, _hoisted_164))
                            ], 2))
                          : (_unref(recording) && !cdrMacroPanelOpen.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                                _createElementVNode("button", {
                                  class: "cdr-rec-cancel",
                                  onClick: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_unref(cancelRecording) && _unref(cancelRecording)(...args))),
                                  title: "Cancelar gravação"
                                }, [...(_cache[139] || (_cache[139] = [
                                  _createElementVNode("svg", {
                                    width: "13",
                                    height: "13",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "3",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("line", {
                                      x1: "18",
                                      y1: "6",
                                      x2: "6",
                                      y2: "18"
                                    }),
                                    _createElementVNode("line", {
                                      x1: "6",
                                      y1: "6",
                                      x2: "18",
                                      y2: "18"
                                    })
                                  ], -1)
                                ]))]),
                                _cache[141] || (_cache[141] = _createElementVNode("span", { class: "cdr-rec-dot" }, null, -1)),
                                _createElementVNode("div", _hoisted_168, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(waveformBars), (h, i) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: i,
                                      class: "cdr-rec-bar",
                                      style: _normalizeStyle({ height: h + 'px' })
                                    }, null, 4))
                                  }), 128))
                                ]),
                                _createElementVNode("span", _hoisted_169, _toDisplayString(_unref(fmtRecordingTime)(_unref(recordingTime))), 1),
                                _createElementVNode("button", {
                                  class: "cdr-rec-stop",
                                  onClick: _cache[48] || (_cache[48] = 
//@ts-ignore
(...args) => (_unref(stopRecording) && _unref(stopRecording)(...args))),
                                  title: "Parar e revisar"
                                }, [...(_cache[140] || (_cache[140] = [
                                  _createElementVNode("svg", {
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor"
                                  }, [
                                    _createElementVNode("rect", {
                                      x: "4",
                                      y: "4",
                                      width: "16",
                                      height: "16",
                                      rx: "2"
                                    })
                                  ], -1)
                                ]))])
                              ]))
                            : (_unref(recordedBlob) && !cdrMacroPanelOpen.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                                  _createElementVNode("button", {
                                    class: "cdr-rec-cancel",
                                    onClick: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_unref(cancelRecording) && _unref(cancelRecording)(...args))),
                                    title: "Descartar"
                                  }, [...(_cache[142] || (_cache[142] = [
                                    _createElementVNode("svg", {
                                      width: "13",
                                      height: "13",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "3",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }, [
                                      _createElementVNode("line", {
                                        x1: "18",
                                        y1: "6",
                                        x2: "6",
                                        y2: "18"
                                      }),
                                      _createElementVNode("line", {
                                        x1: "6",
                                        y1: "6",
                                        x2: "18",
                                        y2: "18"
                                      })
                                    ], -1)
                                  ]))]),
                                  _createElementVNode("audio", {
                                    src: _unref(recordedUrl),
                                    controls: "",
                                    preload: "auto",
                                    class: "cdr-rec-audio"
                                  }, null, 8, _hoisted_171),
                                  _createElementVNode("button", {
                                    class: "cdr-rec-send",
                                    onClick: _cache[50] || (_cache[50] = 
//@ts-ignore
(...args) => (_unref(sendRecordedAudio) && _unref(sendRecordedAudio)(...args))),
                                    title: "Enviar áudio"
                                  }, [...(_cache[143] || (_cache[143] = [
                                    _createElementVNode("svg", {
                                      width: "14",
                                      height: "14",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2.5",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }, [
                                      _createElementVNode("line", {
                                        x1: "22",
                                        y1: "2",
                                        x2: "11",
                                        y2: "13"
                                      }),
                                      _createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" })
                                    ], -1)
                                  ]))])
                                ]))
                              : (videoRecording.value && !cdrMacroPanelOpen.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_172, [
                                    _createElementVNode("video", {
                                      ref_key: "videoPreviewEl",
                                      ref: videoPreviewEl,
                                      muted: "",
                                      autoplay: "",
                                      playsinline: "",
                                      class: "cdr-vrec-preview"
                                    }, null, 512),
                                    _createElementVNode("div", _hoisted_173, [
                                      _createElementVNode("button", {
                                        class: "cdr-rec-cancel",
                                        onClick: cancelVideoRecording,
                                        title: "Cancelar gravação"
                                      }, [...(_cache[144] || (_cache[144] = [
                                        _createElementVNode("svg", {
                                          width: "13",
                                          height: "13",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "3",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        }, [
                                          _createElementVNode("line", {
                                            x1: "18",
                                            y1: "6",
                                            x2: "6",
                                            y2: "18"
                                          }),
                                          _createElementVNode("line", {
                                            x1: "6",
                                            y1: "6",
                                            x2: "18",
                                            y2: "18"
                                          })
                                        ], -1)
                                      ]))]),
                                      _cache[146] || (_cache[146] = _createElementVNode("span", { class: "cdr-rec-dot" }, null, -1)),
                                      _createElementVNode("span", _hoisted_174, _toDisplayString(_unref(fmtRecordingTime)(videoRecordingTime.value)), 1),
                                      _createElementVNode("button", {
                                        class: "cdr-rec-stop",
                                        onClick: stopVideoRecording,
                                        title: "Parar e revisar"
                                      }, [...(_cache[145] || (_cache[145] = [
                                        _createElementVNode("svg", {
                                          width: "14",
                                          height: "14",
                                          viewBox: "0 0 24 24",
                                          fill: "currentColor"
                                        }, [
                                          _createElementVNode("rect", {
                                            x: "4",
                                            y: "4",
                                            width: "16",
                                            height: "16",
                                            rx: "2"
                                          })
                                        ], -1)
                                      ]))])
                                    ])
                                  ]))
                                : (videoRecordedBlob.value && !cdrMacroPanelOpen.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
                                      _createElementVNode("video", {
                                        src: videoRecordedUrl.value,
                                        controls: "",
                                        preload: "auto",
                                        class: "cdr-vrec-preview"
                                      }, null, 8, _hoisted_176),
                                      _createElementVNode("div", { class: "cdr-vrec-bar" }, [
                                        _createElementVNode("button", {
                                          class: "cdr-rec-cancel",
                                          onClick: cancelVideoRecording,
                                          title: "Descartar"
                                        }, [...(_cache[147] || (_cache[147] = [
                                          _createElementVNode("svg", {
                                            width: "13",
                                            height: "13",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            "stroke-width": "3",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                          }, [
                                            _createElementVNode("line", {
                                              x1: "18",
                                              y1: "6",
                                              x2: "6",
                                              y2: "18"
                                            }),
                                            _createElementVNode("line", {
                                              x1: "6",
                                              y1: "6",
                                              x2: "18",
                                              y2: "18"
                                            })
                                          ], -1)
                                        ]))]),
                                        _cache[149] || (_cache[149] = _createElementVNode("span", { style: {"flex":"1","font-size":"12px","color":"#6b7280"} }, "Pronto para enviar", -1)),
                                        _createElementVNode("button", {
                                          class: "cdr-rec-send",
                                          onClick: sendRecordedVideo,
                                          title: "Enviar vídeo"
                                        }, [...(_cache[148] || (_cache[148] = [
                                          _createElementVNode("svg", {
                                            width: "14",
                                            height: "14",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            "stroke-width": "2.5",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                          }, [
                                            _createElementVNode("line", {
                                              x1: "22",
                                              y1: "2",
                                              x2: "11",
                                              y2: "13"
                                            }),
                                            _createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" })
                                          ], -1)
                                        ]))])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_unref(cdrTplOpen))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "cdr-tpl-overlay",
            onMousedown: _cache[56] || (_cache[56] = _withModifiers(
//@ts-ignore
(...args) => (_unref(closeCdrTplModal) && _unref(closeCdrTplModal)(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_177, [
              _createElementVNode("div", _hoisted_178, [
                _createElementVNode("div", _hoisted_179, [
                  _cache[150] || (_cache[150] = _createElementVNode("svg", {
                    width: "15",
                    height: "15",
                    viewBox: "0 0 24 24",
                    fill: "#25D366"
                  }, [
                    _createElementVNode("path", { d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zm-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884zm8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" })
                  ], -1)),
                  _cache[151] || (_cache[151] = _createTextVNode(" Enviar Template WhatsApp ", -1)),
                  _createElementVNode("span", _hoisted_180, "→ " + _toDisplayString(activeConv.value?.contactName), 1)
                ]),
                _createElementVNode("button", {
                  class: "cdr-tpl-close",
                  onClick: _cache[51] || (_cache[51] = 
//@ts-ignore
(...args) => (_unref(closeCdrTplModal) && _unref(closeCdrTplModal)(...args)))
                }, [...(_cache[152] || (_cache[152] = [
                  _createElementVNode("svg", {
                    width: "15",
                    height: "15",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5"
                  }, [
                    _createElementVNode("path", { d: "M18 6 6 18M6 6l12 12" })
                  ], -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_181, [
                _createElementVNode("div", _hoisted_182, [
                  _cache[154] || (_cache[154] = _createElementVNode("div", { class: "cdr-tpl-col-lbl" }, "Templates aprovados", -1)),
                  (_unref(cdrTplsLoading))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_183, [...(_cache[153] || (_cache[153] = [
                        _createElementVNode("span", { class: "cdr-tpl-spin" }, null, -1),
                        _createTextVNode(" Carregando…", -1)
                      ]))]))
                    : (!_unref(cdrTplsApproved).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_184, "Nenhum template aprovado"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_185, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cdrTplsApproved), (t) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: t.id,
                              class: _normalizeClass(["cdr-tpl-item", { active: _unref(cdrTplSel)?.id === t.id }]),
                              onClick: ($event: any) => (_unref(selectCdrTpl)(t))
                            }, [
                              _createElementVNode("div", _hoisted_187, _toDisplayString(t.name.replace(/_/g,' ')), 1),
                              _createElementVNode("div", _hoisted_188, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["cdr-tpl-cat", t.category.toLowerCase()])
                                }, _toDisplayString(t.category === 'MARKETING' ? 'Marketing' : 'Utilidade'), 3),
                                _createElementVNode("span", _hoisted_189, _toDisplayString(t.language), 1)
                              ])
                            ], 10, _hoisted_186))
                          }), 128))
                        ]))
                ]),
                _createElementVNode("div", _hoisted_190, [
                  (!_unref(cdrTplSel))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_191, [...(_cache[155] || (_cache[155] = [
                        _createElementVNode("svg", {
                          width: "28",
                          height: "28",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "1.5"
                        }, [
                          _createElementVNode("path", { d: "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" }),
                          _createElementVNode("rect", {
                            x: "9",
                            y: "3",
                            width: "6",
                            height: "4",
                            rx: "1"
                          })
                        ], -1),
                        _createElementVNode("span", null, "Selecione um template ao lado", -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[162] || (_cache[162] = _createElementVNode("div", {
                          class: "cdr-tpl-col-lbl",
                          style: {"margin-bottom":"8px"}
                        }, "Preview em tempo real", -1)),
                        _createElementVNode("div", _hoisted_192, [
                          _createElementVNode("div", _hoisted_193, [
                            (_unref(cdrTplHasImg))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_194, [
                                  (_unref(cdrTplImgUrl) && !_unref(cdrTplImgErr))
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _unref(cdrTplImgUrl),
                                        alt: "",
                                        onError: _cache[52] || (_cache[52] = ($event: any) => (cdrTplImgErr.value = true))
                                      }, null, 40, _hoisted_195))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_196, [...(_cache[156] || (_cache[156] = [
                                        _createElementVNode("svg", {
                                          width: "22",
                                          height: "22",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "1.5"
                                        }, [
                                          _createElementVNode("rect", {
                                            x: "3",
                                            y: "3",
                                            width: "18",
                                            height: "18",
                                            rx: "2"
                                          }),
                                          _createElementVNode("circle", {
                                            cx: "8.5",
                                            cy: "8.5",
                                            r: "1.5"
                                          }),
                                          _createElementVNode("path", { d: "M21 15l-5-5L5 21" })
                                        ], -1)
                                      ]))]))
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(cdrTplHeaderTxt))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_197, _toDisplayString(_unref(cdrTplHeaderTxt)), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              class: "cdr-tpl-bubble-body",
                              innerHTML: _unref(cdrTplPreviewHtml)
                            }, null, 8, _hoisted_198),
                            (_unref(cdrTplFooterTxt))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_199, _toDisplayString(_unref(cdrTplFooterTxt)), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_200, _toDisplayString(_unref(cdrTplTime)), 1)
                          ]),
                          (_unref(cdrTplButtons).length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_201, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cdrTplButtons), (b, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: i,
                                    class: "cdr-tpl-btn"
                                  }, _toDisplayString(b.text || 'Botão'), 1))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_unref(cdrTplHasImg))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_202, [
                              _cache[157] || (_cache[157] = _createElementVNode("div", { class: "cdr-tpl-field-lbl" }, "URL da imagem", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "url",
                                class: "cdr-tpl-input",
                                "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => (_isRef(cdrTplImgUrl) ? (cdrTplImgUrl).value = $event : null)),
                                placeholder: "https://…",
                                onInput: _cache[54] || (_cache[54] = ($event: any) => (cdrTplImgErr.value = false))
                              }, null, 544), [
                                [_vModelText, _unref(cdrTplImgUrl)]
                              ]),
                              _cache[158] || (_cache[158] = _createElementVNode("div", { class: "cdr-tpl-hint" }, "Use uma URL pública permanente", -1))
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(cdrTplVarNums).length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_203, [
                              _cache[160] || (_cache[160] = _createElementVNode("div", {
                                class: "cdr-tpl-col-lbl",
                                style: {"margin-bottom":"6px"}
                              }, "Variáveis", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cdrTplVarNums), (n) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: n,
                                  style: {"margin-bottom":"7px"}
                                }, [
                                  _createElementVNode("div", _hoisted_204, "Variável {{" + _toDisplayString(n) + "}}", 1),
                                  (_unref(cdrTplVarMapping)[n])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                                        _cache[159] || (_cache[159] = _createElementVNode("svg", {
                                          width: "12",
                                          height: "12",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2.5",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        }, [
                                          _createElementVNode("path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" }),
                                          _createElementVNode("path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" })
                                        ], -1)),
                                        _createTextVNode(" Preenchido automaticamente: " + _toDisplayString(_unref(cdrMappedLabel)(n)), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("input", {
                                        key: 1,
                                        type: "text",
                                        class: "cdr-tpl-input",
                                        placeholder: `Valor para {{${n}}}`,
                                        value: _unref(cdrTplVars)[n] || '',
                                        onInput: ($event: any) => (_unref(setCdrTplVar)(n, ($event.target as HTMLInputElement).value))
                                      }, null, 40, _hoisted_206))
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_207, [
                          _createElementVNode("button", {
                            class: "cdr-tpl-send-btn",
                            disabled: _unref(cdrTplSending),
                            onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_unref(sendCdrTpl) && _unref(sendCdrTpl)(...args)))
                          }, [
                            (!_unref(cdrTplSending))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_209, [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_210, [...(_cache[161] || (_cache[161] = [
                                    _createElementVNode("line", {
                                      x1: "22",
                                      y1: "2",
                                      x2: "11",
                                      y2: "13"
                                    }, null, -1),
                                    _createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" }, null, -1)
                                  ]))])),
                                  _createTextVNode(" Enviar para " + _toDisplayString(activeConv.value?.contactName), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_211))
                          ], 8, _hoisted_208)
                        ])
                      ], 64))
                ])
              ])
            ])
          ], 32))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})